//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import dayjs, { PluginFunc } from "dayjs";
import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken,
} from "axios";

export class AdminClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  startImpersonation(
    email: string,
    cancelToken?: CancelToken,
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/Admin/start/{email}";
    if (email === undefined || email === null)
      throw new globalThis.Error("The parameter 'email' must be defined.");
    url_ = url_.replace("{email}", encodeURIComponent("" + email));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processStartImpersonation(_response);
      });
  }

  protected processStartImpersonation(
    response: AxiosResponse,
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<string>(null as any);
  }

  sendTestEmail(
    templateKey: string | undefined,
    cancelToken?: CancelToken,
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/Admin/send-test-email?";
    if (templateKey === null)
      throw new globalThis.Error("The parameter 'templateKey' cannot be null.");
    else if (templateKey !== undefined)
      url_ += "templateKey=" + encodeURIComponent("" + templateKey) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSendTestEmail(_response);
      });
  }

  protected processSendTestEmail(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<string>(null as any);
  }

  grantTrial(email: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/Admin/grant-trial/{email}";
    if (email === undefined || email === null)
      throw new globalThis.Error("The parameter 'email' must be defined.");
    url_ = url_.replace("{email}", encodeURIComponent("" + email));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGrantTrial(_response);
      });
  }

  protected processGrantTrial(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class AnalyticsClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getCategoryDataSummary(
    categoryId: string | undefined,
    yearsIds: number[] | null | undefined,
    transactionTypes: number[] | undefined,
    cancelToken?: CancelToken,
  ): Promise<CategoryDataSummary[]> {
    let url_ = this.baseUrl + "/api/v1/Analytics/category-data-summary?";
    if (categoryId === null)
      throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
    else if (categoryId !== undefined)
      url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
    if (yearsIds !== undefined && yearsIds !== null)
      yearsIds &&
        yearsIds.forEach((item) => {
          url_ += "YearsIds=" + encodeURIComponent("" + item) + "&";
        });
    if (transactionTypes === null)
      throw new globalThis.Error(
        "The parameter 'transactionTypes' cannot be null.",
      );
    else if (transactionTypes !== undefined)
      transactionTypes &&
        transactionTypes.forEach((item) => {
          url_ += "TransactionTypes=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCategoryDataSummary(_response);
      });
  }

  protected processGetCategoryDataSummary(
    response: AxiosResponse,
  ): Promise<CategoryDataSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(CategoryDataSummary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<CategoryDataSummary[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<CategoryDataSummary[]>(null as any);
  }

  getAggregateDataSummary(
    aggregationType: AggregationTypes | undefined,
    yearIds: number[] | null | undefined,
    transactionTypeIds: number[] | undefined,
    coAgentIds: number[] | undefined,
    includeUnderContracts: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<AggregateDataSummary[]> {
    let url_ = this.baseUrl + "/api/v1/Analytics/aggregate-data-summary?";
    if (aggregationType === null)
      throw new globalThis.Error(
        "The parameter 'aggregationType' cannot be null.",
      );
    else if (aggregationType !== undefined)
      url_ +=
        "AggregationType=" + encodeURIComponent("" + aggregationType) + "&";
    if (yearIds !== undefined && yearIds !== null)
      yearIds &&
        yearIds.forEach((item) => {
          url_ += "YearIds=" + encodeURIComponent("" + item) + "&";
        });
    if (transactionTypeIds === null)
      throw new globalThis.Error(
        "The parameter 'transactionTypeIds' cannot be null.",
      );
    else if (transactionTypeIds !== undefined)
      transactionTypeIds &&
        transactionTypeIds.forEach((item) => {
          url_ += "TransactionTypeIds=" + encodeURIComponent("" + item) + "&";
        });
    if (coAgentIds !== undefined && coAgentIds !== null)
      coAgentIds &&
        coAgentIds.forEach((item) => {
          url_ += "CoAgentIds=" + encodeURIComponent("" + item) + "&";
        });
    if (includeUnderContracts === null)
      throw new globalThis.Error(
        "The parameter 'includeUnderContracts' cannot be null.",
      );
    else if (includeUnderContracts !== undefined)
      url_ +=
        "IncludeUnderContracts=" +
        encodeURIComponent("" + includeUnderContracts) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAggregateDataSummary(_response);
      });
  }

  protected processGetAggregateDataSummary(
    response: AxiosResponse,
  ): Promise<AggregateDataSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(AggregateDataSummary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<AggregateDataSummary[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<AggregateDataSummary[]>(null as any);
  }

  getFinancialCategoryDataSummary(
    categoryId: FinancialCategoryEnum | undefined,
    yearIds: number[] | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<FinancialCategoryDataSummary[]> {
    let url_ =
      this.baseUrl + "/api/v1/Analytics/financial-category-data-summary?";
    if (categoryId === null)
      throw new globalThis.Error("The parameter 'categoryId' cannot be null.");
    else if (categoryId !== undefined)
      url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
    if (yearIds !== undefined && yearIds !== null)
      yearIds &&
        yearIds.forEach((item) => {
          url_ += "YearIds=" + encodeURIComponent("" + item) + "&";
        });
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFinancialCategoryDataSummary(_response);
      });
  }

  protected processGetFinancialCategoryDataSummary(
    response: AxiosResponse,
  ): Promise<FinancialCategoryDataSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(FinancialCategoryDataSummary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<FinancialCategoryDataSummary[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FinancialCategoryDataSummary[]>(null as any);
  }

  getBusinessPlanningData(
    yearIds: number[] | null | undefined,
    forecastYear: string | undefined,
    categories: string[] | undefined,
    onlySb: boolean | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<BusinessPlanningDataResponse> {
    let url_ = this.baseUrl + "/api/v1/Analytics/business-planning-data?";
    if (yearIds !== undefined && yearIds !== null)
      yearIds &&
        yearIds.forEach((item) => {
          url_ += "YearIds=" + encodeURIComponent("" + item) + "&";
        });
    if (forecastYear === null)
      throw new globalThis.Error(
        "The parameter 'forecastYear' cannot be null.",
      );
    else if (forecastYear !== undefined)
      url_ += "ForecastYear=" + encodeURIComponent("" + forecastYear) + "&";
    if (categories === null)
      throw new globalThis.Error("The parameter 'categories' cannot be null.");
    else if (categories !== undefined)
      categories &&
        categories.forEach((item) => {
          url_ += "Categories=" + encodeURIComponent("" + item) + "&";
        });
    if (onlySb !== undefined && onlySb !== null)
      url_ += "OnlySb=" + encodeURIComponent("" + onlySb) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBusinessPlanningData(_response);
      });
  }

  protected processGetBusinessPlanningData(
    response: AxiosResponse,
  ): Promise<BusinessPlanningDataResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BusinessPlanningDataResponse.fromJS(resultData200);
      return Promise.resolve<BusinessPlanningDataResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BusinessPlanningDataResponse>(null as any);
  }

  getBusinessZonesData(
    yearIds: number[] | null | undefined,
    greenThreshold: number | undefined,
    yellowThreshold: number | undefined,
    zoneMetric: string | undefined,
    cancelToken?: CancelToken,
  ): Promise<BusinessZonesResponse> {
    let url_ = this.baseUrl + "/api/v1/Analytics/business-zones?";
    if (yearIds !== undefined && yearIds !== null)
      yearIds &&
        yearIds.forEach((item) => {
          url_ += "YearIds=" + encodeURIComponent("" + item) + "&";
        });
    if (greenThreshold === null)
      throw new globalThis.Error(
        "The parameter 'greenThreshold' cannot be null.",
      );
    else if (greenThreshold !== undefined)
      url_ += "GreenThreshold=" + encodeURIComponent("" + greenThreshold) + "&";
    if (yellowThreshold === null)
      throw new globalThis.Error(
        "The parameter 'yellowThreshold' cannot be null.",
      );
    else if (yellowThreshold !== undefined)
      url_ +=
        "YellowThreshold=" + encodeURIComponent("" + yellowThreshold) + "&";
    if (zoneMetric === null)
      throw new globalThis.Error("The parameter 'zoneMetric' cannot be null.");
    else if (zoneMetric !== undefined)
      url_ += "ZoneMetric=" + encodeURIComponent("" + zoneMetric) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBusinessZonesData(_response);
      });
  }

  protected processGetBusinessZonesData(
    response: AxiosResponse,
  ): Promise<BusinessZonesResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BusinessZonesResponse.fromJS(resultData200);
      return Promise.resolve<BusinessZonesResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BusinessZonesResponse>(null as any);
  }

  getBusinessZonesSettings(
    cancelToken?: CancelToken,
  ): Promise<BusinessZonesSettings> {
    let url_ = this.baseUrl + "/api/v1/Analytics/business-zones-settings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBusinessZonesSettings(_response);
      });
  }

  protected processGetBusinessZonesSettings(
    response: AxiosResponse,
  ): Promise<BusinessZonesSettings> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BusinessZonesSettings.fromJS(resultData200);
      return Promise.resolve<BusinessZonesSettings>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BusinessZonesSettings>(null as any);
  }

  saveBusinessZonesSettings(
    settings: BusinessZonesSettings,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Analytics/business-zones-settings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(settings);

    let options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveBusinessZonesSettings(_response);
      });
  }

  protected processSaveBusinessZonesSettings(
    response: AxiosResponse,
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition,
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class ChatClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  askQuestion(question: string, cancelToken?: CancelToken): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/Chat/ask";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(question);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAskQuestion(_response);
      });
  }

  protected processAskQuestion(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<string>(null as any);
  }

  processConversation(
    request: ChatRequest,
    cancelToken?: CancelToken,
  ): Promise<ChatResponse> {
    let url_ = this.baseUrl + "/api/v1/Chat/conversation";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processProcessConversation(_response);
      });
  }

  protected processProcessConversation(
    response: AxiosResponse,
  ): Promise<ChatResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ChatResponse.fromJS(resultData200);
      return Promise.resolve<ChatResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<ChatResponse>(null as any);
  }

  getSessions(cancelToken?: CancelToken): Promise<any[]> {
    let url_ = this.baseUrl + "/api/v1/Chat/sessions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSessions(_response);
      });
  }

  protected processGetSessions(response: AxiosResponse): Promise<any[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = null as any;
      }
      return Promise.resolve<any[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<any[]>(null as any);
  }

  getSession(
    sessionId: string,
    cancelToken?: CancelToken,
  ): Promise<ConversationSession> {
    let url_ = this.baseUrl + "/api/v1/Chat/sessions/{sessionId}";
    if (sessionId === undefined || sessionId === null)
      throw new globalThis.Error("The parameter 'sessionId' must be defined.");
    url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSession(_response);
      });
  }

  protected processGetSession(
    response: AxiosResponse,
  ): Promise<ConversationSession> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ConversationSession.fromJS(resultData200);
      return Promise.resolve<ConversationSession>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<ConversationSession>(null as any);
  }

  deleteSession(sessionId: string, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/Chat/sessions/{sessionId}";
    if (sessionId === undefined || sessionId === null)
      throw new globalThis.Error("The parameter 'sessionId' must be defined.");
    url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSession(_response);
      });
  }

  protected processDeleteSession(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  explainJsonData(
    request: JsonExplanationRequest,
    cancelToken?: CancelToken,
  ): Promise<JsonExplanationResponse> {
    let url_ = this.baseUrl + "/api/v1/Chat/explain-json";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processExplainJsonData(_response);
      });
  }

  protected processExplainJsonData(
    response: AxiosResponse,
  ): Promise<JsonExplanationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = JsonExplanationResponse.fromJS(resultData200);
      return Promise.resolve<JsonExplanationResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<JsonExplanationResponse>(null as any);
  }
}

export class CommonClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getCommonData(cancelToken?: CancelToken): Promise<CommonData> {
    let url_ = this.baseUrl + "/api/v1/Common/data";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCommonData(_response);
      });
  }

  protected processGetCommonData(response: AxiosResponse): Promise<CommonData> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CommonData.fromJS(resultData200);
      return Promise.resolve<CommonData>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<CommonData>(null as any);
  }

  getUserCommonData(cancelToken?: CancelToken): Promise<CustomUserData> {
    let url_ = this.baseUrl + "/api/v1/Common/user-data";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUserCommonData(_response);
      });
  }

  protected processGetUserCommonData(
    response: AxiosResponse,
  ): Promise<CustomUserData> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = CustomUserData.fromJS(resultData200);
      return Promise.resolve<CustomUserData>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<CustomUserData>(null as any);
  }

  getHiddenFields(cancelToken?: CancelToken): Promise<LookupItem[]> {
    let url_ = this.baseUrl + "/api/v1/Common/hidden-fields";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetHiddenFields(_response);
      });
  }

  protected processGetHiddenFields(
    response: AxiosResponse,
  ): Promise<LookupItem[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(LookupItem.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<LookupItem[]>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<LookupItem[]>(null as any);
  }

  hideField(categoryId: number, cancelToken?: CancelToken): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Common/hide-field";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(categoryId);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processHideField(_response);
      });
  }

  protected processHideField(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  unHideField(id: number, cancelToken?: CancelToken): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Common/unhide-field/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUnHideField(_response);
      });
  }

  protected processUnHideField(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  getCoAgentFilter(cancelToken?: CancelToken): Promise<number[]> {
    let url_ = this.baseUrl + "/api/v1/Common/coagent-filter";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCoAgentFilter(_response);
      });
  }

  protected processGetCoAgentFilter(
    response: AxiosResponse,
  ): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = null as any;
      }
      return Promise.resolve<number[]>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number[]>(null as any);
  }

  saveCoAgentFilter(
    coAgentIds: number[],
    cancelToken?: CancelToken,
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/Common/coagent-filter";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(coAgentIds);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveCoAgentFilter(_response);
      });
  }

  protected processSaveCoAgentFilter(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  getTools(cancelToken?: CancelToken): Promise<ToolState[]> {
    let url_ = this.baseUrl + "/api/v1/Common/tools";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTools(_response);
      });
  }

  protected processGetTools(response: AxiosResponse): Promise<ToolState[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ToolState.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ToolState[]>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<ToolState[]>(null as any);
  }

  setTool(
    name: string,
    enabled: boolean,
    cancelToken?: CancelToken,
  ): Promise<SetToolResponse> {
    let url_ = this.baseUrl + "/api/v1/Common/tools/{name}";
    url_ = url_.replace("{name}", encodeURIComponent("" + name));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify({ enabled });

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSetTool(_response);
      });
  }

  protected processSetTool(response: AxiosResponse): Promise<SetToolResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SetToolResponse.fromJS(resultData200);
      return Promise.resolve<SetToolResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<SetToolResponse>(null as any);
  }

  getConfigurableCategories(
    cancelToken?: CancelToken,
  ): Promise<FormCategory[]> {
    let url_ = this.baseUrl + "/api/v1/Common/categories";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetConfigurableCategories(_response);
      });
  }

  protected processGetConfigurableCategories(
    response: AxiosResponse,
  ): Promise<FormCategory[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(FormCategory.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<FormCategory[]>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FormCategory[]>(null as any);
  }

  addCategoryVariable(
    category: DropDownCategoryEnum | undefined,
    variable: string | undefined,
    cancelToken?: CancelToken,
  ): Promise<number | null> {
    let url_ = this.baseUrl + "/api/v1/Common/category/variable?";
    if (category === null)
      throw new globalThis.Error("The parameter 'category' cannot be null.");
    else if (category !== undefined)
      url_ += "category=" + encodeURIComponent("" + category) + "&";
    if (variable === null)
      throw new globalThis.Error("The parameter 'variable' cannot be null.");
    else if (variable !== undefined)
      url_ += "variable=" + encodeURIComponent("" + variable) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAddCategoryVariable(_response);
      });
  }

  protected processAddCategoryVariable(
    response: AxiosResponse,
  ): Promise<number | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number | null>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number | null>(null as any);
  }

  switchCategoryVariable(
    category: DropDownCategoryEnum | undefined,
    variableId: number | undefined,
    hide: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<number | null> {
    let url_ = this.baseUrl + "/api/v1/Common/category/variable?";
    if (category === null)
      throw new globalThis.Error("The parameter 'category' cannot be null.");
    else if (category !== undefined)
      url_ += "category=" + encodeURIComponent("" + category) + "&";
    if (variableId === null)
      throw new globalThis.Error("The parameter 'variableId' cannot be null.");
    else if (variableId !== undefined)
      url_ += "variableId=" + encodeURIComponent("" + variableId) + "&";
    if (hide === null)
      throw new globalThis.Error("The parameter 'hide' cannot be null.");
    else if (hide !== undefined)
      url_ += "hide=" + encodeURIComponent("" + hide) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSwitchCategoryVariable(_response);
      });
  }

  protected processSwitchCategoryVariable(
    response: AxiosResponse,
  ): Promise<number | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number | null>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number | null>(null as any);
  }

  searchReferrers(
    referrerType: ReferrerTypeEnum | undefined,
    pageIndex: number,
    pageSize: number,
    keyword: string | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<PagedResultOfLookupItemSimple> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/referrers/search/page/{pageIndex}/size/{pageSize}?";
    if (pageIndex === undefined || pageIndex === null)
      throw new globalThis.Error("The parameter 'pageIndex' must be defined.");
    url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
    if (pageSize === undefined || pageSize === null)
      throw new globalThis.Error("The parameter 'pageSize' must be defined.");
    url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
    if (referrerType === null)
      throw new globalThis.Error(
        "The parameter 'referrerType' cannot be null.",
      );
    else if (referrerType !== undefined)
      url_ += "referrerType=" + encodeURIComponent("" + referrerType) + "&";
    if (keyword !== undefined && keyword !== null)
      url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchReferrers(_response);
      });
  }

  protected processSearchReferrers(
    response: AxiosResponse,
  ): Promise<PagedResultOfLookupItemSimple> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PagedResultOfLookupItemSimple.fromJS(resultData200);
      return Promise.resolve<PagedResultOfLookupItemSimple>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PagedResultOfLookupItemSimple>(null as any);
  }

  searchContacts(
    keyword: string | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<LookupItemSimple[]> {
    let url_ = this.baseUrl + "/api/v1/Common/contacts/search?";
    if (keyword !== undefined && keyword !== null)
      url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchContacts(_response);
      });
  }

  protected processSearchContacts(
    response: AxiosResponse,
  ): Promise<LookupItemSimple[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(LookupItemSimple.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<LookupItemSimple[]>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<LookupItemSimple[]>(null as any);
  }

  searchVendors(
    pageIndex: number,
    pageSize: number,
    keyword: string | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<PagedResultOfLookupItemSimple> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/vendors/search/page/{pageIndex}/size/{pageSize}?";
    if (pageIndex === undefined || pageIndex === null)
      throw new globalThis.Error("The parameter 'pageIndex' must be defined.");
    url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
    if (pageSize === undefined || pageSize === null)
      throw new globalThis.Error("The parameter 'pageSize' must be defined.");
    url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
    if (keyword !== undefined && keyword !== null)
      url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchVendors(_response);
      });
  }

  protected processSearchVendors(
    response: AxiosResponse,
  ): Promise<PagedResultOfLookupItemSimple> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PagedResultOfLookupItemSimple.fromJS(resultData200);
      return Promise.resolve<PagedResultOfLookupItemSimple>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PagedResultOfLookupItemSimple>(null as any);
  }

  searchClients(
    pageIndex: number,
    pageSize: number,
    keyword: string | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<PagedResultOfLookupItemSimple> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/clients/search/page/{pageIndex}/size/{pageSize}?";
    if (pageIndex === undefined || pageIndex === null)
      throw new globalThis.Error("The parameter 'pageIndex' must be defined.");
    url_ = url_.replace("{pageIndex}", encodeURIComponent("" + pageIndex));
    if (pageSize === undefined || pageSize === null)
      throw new globalThis.Error("The parameter 'pageSize' must be defined.");
    url_ = url_.replace("{pageSize}", encodeURIComponent("" + pageSize));
    if (keyword !== undefined && keyword !== null)
      url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchClients(_response);
      });
  }

  protected processSearchClients(
    response: AxiosResponse,
  ): Promise<PagedResultOfLookupItemSimple> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PagedResultOfLookupItemSimple.fromJS(resultData200);
      return Promise.resolve<PagedResultOfLookupItemSimple>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PagedResultOfLookupItemSimple>(null as any);
  }

  updateCategoryVariable(
    httpRequest: UpdateCategoryVariableHttpRequest,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Common/update-category-variable";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateCategoryVariable(_response);
      });
  }

  protected processUpdateCategoryVariable(
    response: AxiosResponse,
  ): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  deleteCategoryVariable(
    httpRequest: DeleteCategoryVariableHttpRequest,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Common/delete-category-variable";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteCategoryVariable(_response);
      });
  }

  protected processDeleteCategoryVariable(
    response: AxiosResponse,
  ): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  getBrokerageAnniversaries(
    cancelToken?: CancelToken,
  ): Promise<BrokerageAnniversary[]> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/financial-settings/brokerage-anniversaries";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBrokerageAnniversaries(_response);
      });
  }

  protected processGetBrokerageAnniversaries(
    response: AxiosResponse,
  ): Promise<BrokerageAnniversary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(BrokerageAnniversary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<BrokerageAnniversary[]>(result200);
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BrokerageAnniversary[]>(null as any);
  }

  createBrokerageAnniversary(
    request: CreateBrokerageAnniversaryRequest,
    cancelToken?: CancelToken,
  ): Promise<BrokerageAnniversary> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/financial-settings/brokerage-anniversaries";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateBrokerageAnniversary(_response);
      });
  }

  protected processCreateBrokerageAnniversary(
    response: AxiosResponse,
  ): Promise<BrokerageAnniversary> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = BrokerageAnniversary.fromJS(resultData201);
      return Promise.resolve<BrokerageAnniversary>(result201);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BrokerageAnniversary>(null as any);
  }

  getBrokerageAnniversary(
    id: number,
    cancelToken?: CancelToken,
  ): Promise<BrokerageAnniversary> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/financial-settings/brokerage-anniversaries/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBrokerageAnniversary(_response);
      });
  }

  protected processGetBrokerageAnniversary(
    response: AxiosResponse,
  ): Promise<BrokerageAnniversary> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BrokerageAnniversary.fromJS(resultData200);
      return Promise.resolve<BrokerageAnniversary>(result200);
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BrokerageAnniversary>(null as any);
  }

  updateBrokerageAnniversary(
    id: number,
    request: CreateBrokerageAnniversaryRequest,
    cancelToken?: CancelToken,
  ): Promise<BrokerageAnniversary> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/financial-settings/brokerage-anniversaries/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateBrokerageAnniversary(_response);
      });
  }

  protected processUpdateBrokerageAnniversary(
    response: AxiosResponse,
  ): Promise<BrokerageAnniversary> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BrokerageAnniversary.fromJS(resultData200);
      return Promise.resolve<BrokerageAnniversary>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BrokerageAnniversary>(null as any);
  }

  deleteBrokerageAnniversary(
    id: number,
    cancelToken?: CancelToken,
  ): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/financial-settings/brokerage-anniversaries/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteBrokerageAnniversary(_response);
      });
  }

  protected processDeleteBrokerageAnniversary(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  getActiveBrokerageAnniversaryForDate(
    date: dayjs.Dayjs | undefined,
    cancelToken?: CancelToken,
  ): Promise<BrokerageAnniversary> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/financial-settings/brokerage-anniversaries/active-for-date?";
    if (date === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
      url_ +=
        "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetActiveBrokerageAnniversaryForDate(_response);
      });
  }

  protected processGetActiveBrokerageAnniversaryForDate(
    response: AxiosResponse,
  ): Promise<BrokerageAnniversary> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BrokerageAnniversary.fromJS(resultData200);
      return Promise.resolve<BrokerageAnniversary>(result200);
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<BrokerageAnniversary>(null as any);
  }

  upsertUserArea(
    request: UpsertUserAreaRequest,
    cancelToken?: CancelToken,
  ): Promise<UserAreaResponse> {
    let url_ = this.baseUrl + "/api/v1/Common/user-area";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertUserArea(_response);
      });
  }

  protected processUpsertUserArea(
    response: AxiosResponse,
  ): Promise<UserAreaResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserAreaResponse.fromJS(resultData200);
      return Promise.resolve<UserAreaResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<UserAreaResponse>(null as any);
  }

  getPendingDuplicateCandidates(
    cancelToken?: CancelToken,
  ): Promise<DuplicateCandidateResponse[]> {
    let url_ = this.baseUrl + "/api/v1/Common/duplicate-candidates";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPendingDuplicateCandidates(_response);
      });
  }

  protected processGetPendingDuplicateCandidates(
    response: AxiosResponse,
  ): Promise<DuplicateCandidateResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(DuplicateCandidateResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<DuplicateCandidateResponse[]>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<DuplicateCandidateResponse[]>(null as any);
  }

  resolveDuplicateCandidate(
    request: ResolveDuplicateCandidateRequest,
    cancelToken?: CancelToken,
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/Common/duplicate-candidates/resolve";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processResolveDuplicateCandidate(_response);
      });
  }

  protected processResolveDuplicateCandidate(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ValidationProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }

  recalculateFinancialSettings(cancelToken?: CancelToken): Promise<void> {
    let url_ =
      this.baseUrl +
      "/api/v1/Common/financial-settings/brokerage-anniversaries/recalculate";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRecalculateFinancialSettings(_response);
      });
  }

  protected processRecalculateFinancialSettings(
    response: AxiosResponse,
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result401,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class DocumentClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  uploadFiles(
    files: FileParameter[] | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<ExtractSettlementDataHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/Document/upload";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (files !== null && files !== undefined)
      files.forEach((item_) =>
        content_.append(
          "files",
          item_.data,
          item_.fileName ? item_.fileName : "files",
        ),
      );

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUploadFiles(_response);
      });
  }

  protected processUploadFiles(
    response: AxiosResponse,
  ): Promise<ExtractSettlementDataHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ExtractSettlementDataHttpResponse.fromJS(resultData200);
      return Promise.resolve<ExtractSettlementDataHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<ExtractSettlementDataHttpResponse>(null as any);
  }
}

export class EmailTemplateClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getAllTemplates(cancelToken?: CancelToken): Promise<EmailTemplate[]> {
    let url_ = this.baseUrl + "/api/v1/EmailTemplate";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetAllTemplates(_response);
      });
  }

  protected processGetAllTemplates(
    response: AxiosResponse,
  ): Promise<EmailTemplate[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(EmailTemplate.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<EmailTemplate[]>(result200);
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<EmailTemplate[]>(null as any);
  }

  getTemplateById(
    id: number,
    cancelToken?: CancelToken,
  ): Promise<EmailTemplate> {
    let url_ = this.baseUrl + "/api/v1/EmailTemplate/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTemplateById(_response);
      });
  }

  protected processGetTemplateById(
    response: AxiosResponse,
  ): Promise<EmailTemplate> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = EmailTemplate.fromJS(resultData200);
      return Promise.resolve<EmailTemplate>(result200);
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<EmailTemplate>(null as any);
  }

  updateTemplate(
    id: number,
    request: UpdateEmailTemplateRequest,
    cancelToken?: CancelToken,
  ): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/EmailTemplate/{id}";
    if (id === undefined || id === null)
      throw new globalThis.Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateTemplate(_response);
      });
  }

  protected processUpdateTemplate(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 403) {
      const _responseText = response.data;
      let result403: any = null;
      let resultData403 = _responseText;
      result403 = ProblemDetails.fromJS(resultData403);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result403,
      );
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<void>(null as any);
  }
}

export class GciTrackerClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getSettings(cancelToken?: CancelToken): Promise<GciTrackerSettingsResponse> {
    let url_ = this.baseUrl + "/api/v1/gci-tracker/settings";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSettings(_response);
      });
  }

  protected processGetSettings(
    response: AxiosResponse,
  ): Promise<GciTrackerSettingsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GciTrackerSettingsResponse.fromJS(resultData200);
      return Promise.resolve<GciTrackerSettingsResponse>(result200);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<GciTrackerSettingsResponse>(null as any);
  }

  updateSettings(
    request: UpdateGciTrackerSettingsRequest,
    cancelToken?: CancelToken,
  ): Promise<GciTrackerSettingsResponse> {
    let url_ = this.baseUrl + "/api/v1/gci-tracker/settings";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSettings(_response);
      });
  }

  protected processUpdateSettings(
    response: AxiosResponse,
  ): Promise<GciTrackerSettingsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GciTrackerSettingsResponse.fromJS(resultData200);
      return Promise.resolve<GciTrackerSettingsResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<GciTrackerSettingsResponse>(null as any);
  }
}

export class PaymentClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getPricingTable(cancelToken?: CancelToken): Promise<PriceInfo[]> {
    let url_ = this.baseUrl + "/api/v1/Payment/pricing-table";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPricingTable(_response);
      });
  }

  protected processGetPricingTable(
    response: AxiosResponse,
  ): Promise<PriceInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(PriceInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<PriceInfo[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PriceInfo[]>(null as any);
  }
}

export class PropMixAdminClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getStats(
    userId: string | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<PropMixStatsResponse> {
    let url_ = this.baseUrl + "/api/v1/admin/propmix/stats?";
    if (userId !== undefined && userId !== null)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetStats(_response);
      });
  }

  protected processGetStats(
    response: AxiosResponse,
  ): Promise<PropMixStatsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PropMixStatsResponse.fromJS(resultData200);
      return Promise.resolve<PropMixStatsResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PropMixStatsResponse>(null as any);
  }

  getUsersWithFailures(
    cancelToken?: CancelToken,
  ): Promise<PropMixUserSummaryDto[]> {
    let url_ = this.baseUrl + "/api/v1/admin/propmix/users";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUsersWithFailures(_response);
      });
  }

  protected processGetUsersWithFailures(
    response: AxiosResponse,
  ): Promise<PropMixUserSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(PropMixUserSummaryDto.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<PropMixUserSummaryDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PropMixUserSummaryDto[]>(null as any);
  }

  exportFailedPropMixLookups(
    batchId: string | undefined,
    userId: string | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/admin/propmix/export-failed-lookups?";
    if (batchId === null)
      throw new globalThis.Error("The parameter 'batchId' cannot be null.");
    else if (batchId !== undefined)
      url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
    if (userId !== undefined && userId !== null)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processExportFailedPropMixLookups(_response);
      });
  }

  protected processExportFailedPropMixLookups(
    response: AxiosResponse,
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition,
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  retryLookup(
    failureId: number,
    cancelToken?: CancelToken,
  ): Promise<PropMixRetryResultDto> {
    let url_ = this.baseUrl + "/api/v1/admin/propmix/retry/{failureId}";
    if (failureId === undefined || failureId === null)
      throw new globalThis.Error("The parameter 'failureId' must be defined.");
    url_ = url_.replace("{failureId}", encodeURIComponent("" + failureId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRetryLookup(_response);
      });
  }

  protected processRetryLookup(
    response: AxiosResponse,
  ): Promise<PropMixRetryResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PropMixRetryResultDto.fromJS(resultData200);
      return Promise.resolve<PropMixRetryResultDto>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PropMixRetryResultDto>(null as any);
  }

  retryAllFailures(
    userId: string | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<PropMixBulkRetryResultDto> {
    let url_ = this.baseUrl + "/api/v1/admin/propmix/retry-all?";
    if (userId !== undefined && userId !== null)
      url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRetryAllFailures(_response);
      });
  }

  protected processRetryAllFailures(
    response: AxiosResponse,
  ): Promise<PropMixBulkRetryResultDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PropMixBulkRetryResultDto.fromJS(resultData200);
      return Promise.resolve<PropMixBulkRetryResultDto>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PropMixBulkRetryResultDto>(null as any);
  }
}

export class WebhookClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  handler(cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Webhook";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processHandler(_response);
      });
  }

  protected processHandler(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition,
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class SubscriptionClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getActiveSubscription(
    cancelToken?: CancelToken,
  ): Promise<ActiveSubscriptionHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/Subscription/subscription";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetActiveSubscription(_response);
      });
  }

  protected processGetActiveSubscription(
    response: AxiosResponse,
  ): Promise<ActiveSubscriptionHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ActiveSubscriptionHttpResponse.fromJS(resultData200);
      return Promise.resolve<ActiveSubscriptionHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<ActiveSubscriptionHttpResponse>(null as any);
  }

  createCustomerPortalSession(cancelToken?: CancelToken): Promise<string> {
    let url_ =
      this.baseUrl + "/api/v1/Subscription/create-customer-portal-session";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateCustomerPortalSession(_response);
      });
  }

  protected processCreateCustomerPortalSession(
    response: AxiosResponse,
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<string>(null as any);
  }
}

export class TransactionClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  createTransactionYear(
    year: number | undefined,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Transaction/create-year?";
    if (year === null)
      throw new globalThis.Error("The parameter 'year' cannot be null.");
    else if (year !== undefined)
      url_ += "year=" + encodeURIComponent("" + year) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateTransactionYear(_response);
      });
  }

  protected processCreateTransactionYear(
    response: AxiosResponse,
  ): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  getTransactionsDashboardSummary(
    yearId: number | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<TransactionSummary[]> {
    let url_ = this.baseUrl + "/api/v1/Transaction/dashboard-summary?";
    if (yearId !== undefined && yearId !== null)
      url_ += "yearId=" + encodeURIComponent("" + yearId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransactionsDashboardSummary(_response);
      });
  }

  protected processGetTransactionsDashboardSummary(
    response: AxiosResponse,
  ): Promise<TransactionSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TransactionSummary.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TransactionSummary[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<TransactionSummary[]>(null as any);
  }

  deleteTransactionYear(
    yearId: number,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Transaction/delete-year/{yearId}";
    if (yearId === undefined || yearId === null)
      throw new globalThis.Error("The parameter 'yearId' must be defined.");
    url_ = url_.replace("{yearId}", encodeURIComponent("" + yearId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteTransactionYear(_response);
      });
  }

  protected processDeleteTransactionYear(
    response: AxiosResponse,
  ): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  getPipelineFolder(cancelToken?: CancelToken): Promise<PipelineFolderInfo> {
    let url_ = this.baseUrl + "/api/v1/Transaction/pipeline";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPipelineFolder(_response);
      });
  }

  protected processGetPipelineFolder(
    response: AxiosResponse,
  ): Promise<PipelineFolderInfo> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PipelineFolderInfo.fromJS(resultData200);
      return Promise.resolve<PipelineFolderInfo>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PipelineFolderInfo>(null as any);
  }

  getTransactionYears(cancelToken?: CancelToken): Promise<TransactionYear[]> {
    let url_ = this.baseUrl + "/api/v1/Transaction/years";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransactionYears(_response);
      });
  }

  protected processGetTransactionYears(
    response: AxiosResponse,
  ): Promise<TransactionYear[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TransactionYear.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TransactionYear[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<TransactionYear[]>(null as any);
  }

  upsertTransaction(
    httpRequest: UpsertTransactionHttpRequest,
    cancelToken?: CancelToken,
  ): Promise<UpsertTransactionResult> {
    let url_ = this.baseUrl + "/api/v1/Transaction/upsert-transaction";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertTransaction(_response);
      });
  }

  protected processUpsertTransaction(
    response: AxiosResponse,
  ): Promise<UpsertTransactionResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UpsertTransactionResult.fromJS(resultData200);
      return Promise.resolve<UpsertTransactionResult>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<UpsertTransactionResult>(null as any);
  }

  upsertFinancials(
    httpRequest: UpsertFinancialsHttpRequest,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Transaction/upsert-financials";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpsertFinancials(_response);
      });
  }

  protected processUpsertFinancials(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  getTransactionsSummary(
    yearId: number | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    transactionTypeIds: number[] | null | undefined,
    sourceIds: number[] | null | undefined,
    reasonIds: number[] | null | undefined,
    clientIds: number[] | null | undefined,
    fromDate: dayjs.Dayjs | null | undefined,
    toDate: dayjs.Dayjs | null | undefined,
    minPrice: number | null | undefined,
    maxPrice: number | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<TransactionInfo[]> {
    let url_ = this.baseUrl + "/api/v1/Transaction/transactions-summary?";
    if (yearId === null)
      throw new globalThis.Error("The parameter 'yearId' cannot be null.");
    else if (yearId !== undefined)
      url_ += "YearId=" + encodeURIComponent("" + yearId) + "&";
    if (pageNumber === null)
      throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
      throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (transactionTypeIds !== undefined && transactionTypeIds !== null)
      transactionTypeIds &&
        transactionTypeIds.forEach((item) => {
          url_ += "TransactionTypeIds=" + encodeURIComponent("" + item) + "&";
        });
    if (sourceIds !== undefined && sourceIds !== null)
      sourceIds &&
        sourceIds.forEach((item) => {
          url_ += "SourceIds=" + encodeURIComponent("" + item) + "&";
        });
    if (reasonIds !== undefined && reasonIds !== null)
      reasonIds &&
        reasonIds.forEach((item) => {
          url_ += "ReasonIds=" + encodeURIComponent("" + item) + "&";
        });
    if (clientIds !== undefined && clientIds !== null)
      clientIds &&
        clientIds.forEach((item) => {
          url_ += "ClientIds=" + encodeURIComponent("" + item) + "&";
        });
    if (fromDate !== undefined && fromDate !== null)
      url_ +=
        "FromDate=" +
        encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") +
        "&";
    if (toDate !== undefined && toDate !== null)
      url_ +=
        "ToDate=" +
        encodeURIComponent(toDate ? "" + toDate.toISOString() : "") +
        "&";
    if (minPrice !== undefined && minPrice !== null)
      url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
    if (maxPrice !== undefined && maxPrice !== null)
      url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransactionsSummary(_response);
      });
  }

  protected processGetTransactionsSummary(
    response: AxiosResponse,
  ): Promise<TransactionInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TransactionInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TransactionInfo[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<TransactionInfo[]>(null as any);
  }

  searchTransactions(
    yearIds: number[] | null | undefined,
    transactionTypeIds: number[] | null | undefined,
    sourceIds: number[] | null | undefined,
    reasonIds: number[] | null | undefined,
    areaIds: number[] | null | undefined,
    specialTagIds: number[] | null | undefined,
    specialGroupIds: number[] | null | undefined,
    referralOutTypeIds: number[] | null | undefined,
    coAgentId: number | null | undefined,
    zipCode: string | null | undefined,
    county: string | null | undefined,
    clientName: string | null | undefined,
    minPrice: number | null | undefined,
    maxPrice: number | null | undefined,
    address: string | null | undefined,
    minDate: dayjs.Dayjs | null | undefined,
    maxDate: dayjs.Dayjs | null | undefined,
    soiReferrerIds: number[] | null | undefined,
    agentReferrerIds: number[] | null | undefined,
    vendorReferrerIds: number[] | null | undefined,
    includeUnderContracts: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<TransactionSearchInfo[]> {
    let url_ = this.baseUrl + "/api/v1/Transaction/search-transactions?";
    if (yearIds !== undefined && yearIds !== null)
      yearIds &&
        yearIds.forEach((item) => {
          url_ += "YearIds=" + encodeURIComponent("" + item) + "&";
        });
    if (transactionTypeIds !== undefined && transactionTypeIds !== null)
      transactionTypeIds &&
        transactionTypeIds.forEach((item) => {
          url_ += "TransactionTypeIds=" + encodeURIComponent("" + item) + "&";
        });
    if (sourceIds !== undefined && sourceIds !== null)
      sourceIds &&
        sourceIds.forEach((item) => {
          url_ += "SourceIds=" + encodeURIComponent("" + item) + "&";
        });
    if (reasonIds !== undefined && reasonIds !== null)
      reasonIds &&
        reasonIds.forEach((item) => {
          url_ += "ReasonIds=" + encodeURIComponent("" + item) + "&";
        });
    if (areaIds !== undefined && areaIds !== null)
      areaIds &&
        areaIds.forEach((item) => {
          url_ += "AreaIds=" + encodeURIComponent("" + item) + "&";
        });
    if (specialTagIds !== undefined && specialTagIds !== null)
      specialTagIds &&
        specialTagIds.forEach((item) => {
          url_ += "SpecialTagIds=" + encodeURIComponent("" + item) + "&";
        });
    if (specialGroupIds !== undefined && specialGroupIds !== null)
      specialGroupIds &&
        specialGroupIds.forEach((item) => {
          url_ += "SpecialGroupIds=" + encodeURIComponent("" + item) + "&";
        });
    if (referralOutTypeIds !== undefined && referralOutTypeIds !== null)
      referralOutTypeIds &&
        referralOutTypeIds.forEach((item) => {
          url_ += "ReferralOutTypeIds=" + encodeURIComponent("" + item) + "&";
        });
    if (coAgentId !== undefined && coAgentId !== null)
      url_ += "CoAgentId=" + encodeURIComponent("" + coAgentId) + "&";
    if (zipCode !== undefined && zipCode !== null)
      url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
    if (county !== undefined && county !== null)
      url_ += "County=" + encodeURIComponent("" + county) + "&";
    if (clientName !== undefined && clientName !== null)
      url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
    if (minPrice !== undefined && minPrice !== null)
      url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
    if (maxPrice !== undefined && maxPrice !== null)
      url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
    if (address !== undefined && address !== null)
      url_ += "Address=" + encodeURIComponent("" + address) + "&";
    if (minDate !== undefined && minDate !== null)
      url_ +=
        "MinDate=" +
        encodeURIComponent(minDate ? "" + minDate.toISOString() : "") +
        "&";
    if (maxDate !== undefined && maxDate !== null)
      url_ +=
        "MaxDate=" +
        encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "") +
        "&";
    if (soiReferrerIds !== undefined && soiReferrerIds !== null)
      soiReferrerIds &&
        soiReferrerIds.forEach((item) => {
          url_ += "SoiReferrerIds=" + encodeURIComponent("" + item) + "&";
        });
    if (agentReferrerIds !== undefined && agentReferrerIds !== null)
      agentReferrerIds &&
        agentReferrerIds.forEach((item) => {
          url_ += "AgentReferrerIds=" + encodeURIComponent("" + item) + "&";
        });
    if (vendorReferrerIds !== undefined && vendorReferrerIds !== null)
      vendorReferrerIds &&
        vendorReferrerIds.forEach((item) => {
          url_ += "VendorReferrerIds=" + encodeURIComponent("" + item) + "&";
        });
    if (includeUnderContracts === null)
      throw new Error("The parameter 'includeUnderContracts' cannot be null.");
    else if (includeUnderContracts !== undefined)
      url_ +=
        "IncludeUnderContracts=" +
        encodeURIComponent("" + includeUnderContracts) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchTransactions(_response);
      });
  }

  protected processSearchTransactions(
    response: AxiosResponse,
  ): Promise<TransactionSearchInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TransactionSearchInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TransactionSearchInfo[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<TransactionSearchInfo[]>(null as any);
  }

  searchTransactionsWithPaging(
    yearIds: number[] | null | undefined,
    transactionTypeIds: number[] | null | undefined,
    sourceIds: number[] | null | undefined,
    reasonIds: number[] | null | undefined,
    areaIds: number[] | null | undefined,
    specialTagIds: number[] | null | undefined,
    specialGroupIds: number[] | null | undefined,
    referralOutTypeIds: number[] | null | undefined,
    coAgentId: number | null | undefined,
    zipCode: string | null | undefined,
    county: string | null | undefined,
    clientName: string | null | undefined,
    minPrice: number | null | undefined,
    maxPrice: number | null | undefined,
    address: string | null | undefined,
    minDate: dayjs.Dayjs | null | undefined,
    maxDate: dayjs.Dayjs | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<PagedResultOfTransactionInfo> {
    let url_ = this.baseUrl + "/api/v1/Transaction/search-transactions-paged?";
    if (yearIds !== undefined && yearIds !== null)
      yearIds &&
        yearIds.forEach((item) => {
          url_ += "YearIds=" + encodeURIComponent("" + item) + "&";
        });
    if (transactionTypeIds !== undefined && transactionTypeIds !== null)
      transactionTypeIds &&
        transactionTypeIds.forEach((item) => {
          url_ += "TransactionTypeIds=" + encodeURIComponent("" + item) + "&";
        });
    if (sourceIds !== undefined && sourceIds !== null)
      sourceIds &&
        sourceIds.forEach((item) => {
          url_ += "SourceIds=" + encodeURIComponent("" + item) + "&";
        });
    if (reasonIds !== undefined && reasonIds !== null)
      reasonIds &&
        reasonIds.forEach((item) => {
          url_ += "ReasonIds=" + encodeURIComponent("" + item) + "&";
        });
    if (areaIds !== undefined && areaIds !== null)
      areaIds &&
        areaIds.forEach((item) => {
          url_ += "AreaIds=" + encodeURIComponent("" + item) + "&";
        });
    if (specialTagIds !== undefined && specialTagIds !== null)
      specialTagIds &&
        specialTagIds.forEach((item) => {
          url_ += "SpecialTagIds=" + encodeURIComponent("" + item) + "&";
        });
    if (specialGroupIds !== undefined && specialGroupIds !== null)
      specialGroupIds &&
        specialGroupIds.forEach((item) => {
          url_ += "SpecialGroupIds=" + encodeURIComponent("" + item) + "&";
        });
    if (referralOutTypeIds !== undefined && referralOutTypeIds !== null)
      referralOutTypeIds &&
        referralOutTypeIds.forEach((item) => {
          url_ += "ReferralOutTypeIds=" + encodeURIComponent("" + item) + "&";
        });
    if (coAgentId !== undefined && coAgentId !== null)
      url_ += "CoAgentId=" + encodeURIComponent("" + coAgentId) + "&";
    if (zipCode !== undefined && zipCode !== null)
      url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
    if (county !== undefined && county !== null)
      url_ += "County=" + encodeURIComponent("" + county) + "&";
    if (clientName !== undefined && clientName !== null)
      url_ += "ClientName=" + encodeURIComponent("" + clientName) + "&";
    if (minPrice !== undefined && minPrice !== null)
      url_ += "MinPrice=" + encodeURIComponent("" + minPrice) + "&";
    if (maxPrice !== undefined && maxPrice !== null)
      url_ += "MaxPrice=" + encodeURIComponent("" + maxPrice) + "&";
    if (address !== undefined && address !== null)
      url_ += "Address=" + encodeURIComponent("" + address) + "&";
    if (minDate !== undefined && minDate !== null)
      url_ +=
        "MinDate=" +
        encodeURIComponent(minDate ? "" + minDate.toISOString() : "") +
        "&";
    if (maxDate !== undefined && maxDate !== null)
      url_ +=
        "MaxDate=" +
        encodeURIComponent(maxDate ? "" + maxDate.toISOString() : "") +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearchTransactionsWithPaging(_response);
      });
  }

  protected processSearchTransactionsWithPaging(
    response: AxiosResponse,
  ): Promise<PagedResultOfTransactionInfo> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PagedResultOfTransactionInfo.fromJS(resultData200);
      return Promise.resolve<PagedResultOfTransactionInfo>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PagedResultOfTransactionInfo>(null as any);
  }

  getTransaction(
    transactionId: number | undefined,
    cancelToken?: CancelToken,
  ): Promise<GetTransactionHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/Transaction/transaction?";
    if (transactionId === null)
      throw new globalThis.Error(
        "The parameter 'transactionId' cannot be null.",
      );
    else if (transactionId !== undefined)
      url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransaction(_response);
      });
  }

  protected processGetTransaction(
    response: AxiosResponse,
  ): Promise<GetTransactionHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetTransactionHttpResponse.fromJS(resultData200);
      return Promise.resolve<GetTransactionHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<GetTransactionHttpResponse>(null as any);
  }

  getFinancialDefaultData(
    transactionId: number,
    date: dayjs.Dayjs | undefined,
    cancelToken?: CancelToken,
  ): Promise<PrefillData> {
    let url_ =
      this.baseUrl +
      "/api/v1/Transaction/financial-default-data/{transactionId}?";
    if (transactionId === undefined || transactionId === null)
      throw new globalThis.Error(
        "The parameter 'transactionId' must be defined.",
      );
    url_ = url_.replace(
      "{transactionId}",
      encodeURIComponent("" + transactionId),
    );
    if (date === null)
      throw new globalThis.Error("The parameter 'date' cannot be null.");
    else if (date !== undefined)
      url_ +=
        "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFinancialDefaultData(_response);
      });
  }

  protected processGetFinancialDefaultData(
    response: AxiosResponse,
  ): Promise<PrefillData> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PrefillData.fromJS(resultData200);
      return Promise.resolve<PrefillData>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<PrefillData>(null as any);
  }

  insertSettlementData(
    httpRequest: ImportSettlementDataHttpRequest,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Transaction/insert-settlement-data";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processInsertSettlementData(_response);
      });
  }

  protected processInsertSettlementData(
    response: AxiosResponse,
  ): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  updateLinkage(
    httpRequest: UpdateLinkageHttpRequest,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Transaction/update-linkage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateLinkage(_response);
      });
  }

  protected processUpdateLinkage(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  updatePipelineStatus(
    httpRequest: UpdatePipelineStatusHttpRequest,
    cancelToken?: CancelToken,
  ): Promise<UpsertTransactionResult> {
    let url_ = this.baseUrl + "/api/v1/Transaction/update-pipeline-status";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(httpRequest);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdatePipelineStatus(_response);
      });
  }

  protected processUpdatePipelineStatus(
    response: AxiosResponse,
  ): Promise<UpsertTransactionResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UpsertTransactionResult.fromJS(resultData200);
      return Promise.resolve<UpsertTransactionResult>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = resultData400 !== undefined ? resultData400 : (null as any);

      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result400,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<UpsertTransactionResult>(null as any);
  }

  deleteTransaction(
    transactionId: number | undefined,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/Transaction?";
    if (transactionId === null)
      throw new globalThis.Error(
        "The parameter 'transactionId' cannot be null.",
      );
    else if (transactionId !== undefined)
      url_ += "transactionId=" + encodeURIComponent("" + transactionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteTransaction(_response);
      });
  }

  protected processDeleteTransaction(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<number>(null as any);
  }

  uploadExcelFile(
    duplicateHandle: DuplicateActionEnum | undefined,
    enablePropMixLookup: boolean | undefined,
    file: FileParameter | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<string> {
    let url_ = this.baseUrl + "/api/v1/Transaction/upload-excel?";
    if (duplicateHandle === null)
      throw new globalThis.Error(
        "The parameter 'duplicateHandle' cannot be null.",
      );
    else if (duplicateHandle !== undefined)
      url_ +=
        "duplicateHandle=" + encodeURIComponent("" + duplicateHandle) + "&";
    if (enablePropMixLookup === null)
      throw new globalThis.Error(
        "The parameter 'enablePropMixLookup' cannot be null.",
      );
    else if (enablePropMixLookup !== undefined)
      url_ +=
        "enablePropMixLookup=" +
        encodeURIComponent("" + enablePropMixLookup) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (file !== null && file !== undefined)
      content_.append(
        "file",
        file.data,
        file.fileName ? file.fileName : "file",
      );

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUploadExcelFile(_response);
      });
  }

  protected processUploadExcelFile(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<string>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<string>(null as any);
  }

  exportExcel(cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Transaction/export-excel";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processExportExcel(_response);
      });
  }

  protected processExportExcel(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition,
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  exportFailedImports(
    batchId: string | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Transaction/export-failed-imports?";
    if (batchId === null)
      throw new globalThis.Error("The parameter 'batchId' cannot be null.");
    else if (batchId !== undefined)
      url_ += "batchId=" + encodeURIComponent("" + batchId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processExportFailedImports(_response);
      });
  }

  protected processExportFailedImports(
    response: AxiosResponse,
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(
            contentDisposition,
          )
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName =
          fileNameMatch && fileNameMatch.length > 1
            ? fileNameMatch[1]
            : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers["content-type"],
        }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException(
        "A server side error occurred.",
        status,
        _responseText,
        _headers,
        result404,
      );
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getTransactionRepeats(
    entity: TransactionRepeatEnum | undefined,
    cancelToken?: CancelToken,
  ): Promise<EntityRepeatInfo[]> {
    let url_ = this.baseUrl + "/api/v1/Transaction/transaction-repeats?";
    if (entity === null)
      throw new globalThis.Error("The parameter 'entity' cannot be null.");
    else if (entity !== undefined)
      url_ += "entity=" + encodeURIComponent("" + entity) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransactionRepeats(_response);
      });
  }

  protected processGetTransactionRepeats(
    response: AxiosResponse,
  ): Promise<EntityRepeatInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(EntityRepeatInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<EntityRepeatInfo[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<EntityRepeatInfo[]>(null as any);
  }

  getTransactionsByEntity(
    entity: TransactionRepeatEnum | undefined,
    id: number | undefined,
    cancelToken?: CancelToken,
  ): Promise<TransactionInfo[]> {
    let url_ = this.baseUrl + "/api/v1/Transaction/transactions-by-entity?";
    if (entity === null)
      throw new globalThis.Error("The parameter 'entity' cannot be null.");
    else if (entity !== undefined)
      url_ += "entity=" + encodeURIComponent("" + entity) + "&";
    if (id === null)
      throw new globalThis.Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += "id=" + encodeURIComponent("" + id) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransactionsByEntity(_response);
      });
  }

  protected processGetTransactionsByEntity(
    response: AxiosResponse,
  ): Promise<TransactionInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TransactionInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TransactionInfo[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<TransactionInfo[]>(null as any);
  }

  getTransactionsByEntityName(
    entityId: number | undefined,
    contactTypeId: number | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<TransactionInfo[]> {
    let url_ =
      this.baseUrl + "/api/v1/Transaction/transactions-by-entity-name?";
    if (entityId === null)
      throw new globalThis.Error("The parameter 'entityId' cannot be null.");
    else if (entityId !== undefined)
      url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
    if (contactTypeId !== undefined && contactTypeId !== null)
      url_ += "contactTypeId=" + encodeURIComponent("" + contactTypeId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransactionsByEntityName(_response);
      });
  }

  protected processGetTransactionsByEntityName(
    response: AxiosResponse,
  ): Promise<TransactionInfo[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(TransactionInfo.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<TransactionInfo[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<TransactionInfo[]>(null as any);
  }

  getTransactionNavigation(
    transactionId: number,
    yearId: number | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<TransactionNavigationResponse> {
    let url_ = this.baseUrl + "/api/v1/Transaction/{transactionId}/navigation?";
    if (transactionId === undefined || transactionId === null)
      throw new globalThis.Error(
        "The parameter 'transactionId' must be defined.",
      );
    url_ = url_.replace(
      "{transactionId}",
      encodeURIComponent("" + transactionId),
    );
    if (yearId !== undefined && yearId !== null)
      url_ += "yearId=" + encodeURIComponent("" + yearId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetTransactionNavigation(_response);
      });
  }

  protected processGetTransactionNavigation(
    response: AxiosResponse,
  ): Promise<TransactionNavigationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TransactionNavigationResponse.fromJS(resultData200);
      return Promise.resolve<TransactionNavigationResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<TransactionNavigationResponse>(null as any);
  }
}

export class UserClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getUser(cancelToken?: CancelToken): Promise<User> {
    let url_ = this.baseUrl + "/api/v1/User/get-user";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUser(_response);
      });
  }

  protected processGetUser(response: AxiosResponse): Promise<User> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = User.fromJS(resultData200);
      return Promise.resolve<User>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers,
      );
    }
    return Promise.resolve<User>(null as any);
  }
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class CategoryDataSummary implements ICategoryDataSummary {
  id?: string;
  name?: string;
  totalCount?: number;
  totalAmount?: number;
  sbCount?: number;
  sbAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;

  constructor(data?: ICategoryDataSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.totalCount = _data["totalCount"];
      this.totalAmount = _data["totalAmount"];
      this.sbCount = _data["sbCount"];
      this.sbAmount = _data["sbAmount"];
      this.yearId = _data["yearId"];
      this.month = _data["month"];
      this.quarter = _data["quarter"];
    }
  }

  static fromJS(data: any): CategoryDataSummary {
    data = typeof data === "object" ? data : {};
    let result = new CategoryDataSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["totalCount"] = this.totalCount;
    data["totalAmount"] = this.totalAmount;
    data["sbCount"] = this.sbCount;
    data["sbAmount"] = this.sbAmount;
    data["yearId"] = this.yearId;
    data["month"] = this.month;
    data["quarter"] = this.quarter;
    return data;
  }
}

export interface ICategoryDataSummary {
  id?: string;
  name?: string;
  totalCount?: number;
  totalAmount?: number;
  sbCount?: number;
  sbAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;
}

export class AggregateDataSummary implements IAggregateDataSummary {
  totalCount?: number;
  totalAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;
  year?: number;
  isPipeline?: boolean;
  isUnderContract?: boolean;

  constructor(data?: IAggregateDataSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      this.totalAmount = _data["totalAmount"];
      this.yearId = _data["yearId"];
      this.month = _data["month"];
      this.quarter = _data["quarter"];
      this.year = _data["year"];
      this.isPipeline = _data["isPipeline"];
      this.isUnderContract = _data["isUnderContract"];
    }
  }

  static fromJS(data: any): AggregateDataSummary {
    data = typeof data === "object" ? data : {};
    let result = new AggregateDataSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalCount"] = this.totalCount;
    data["totalAmount"] = this.totalAmount;
    data["yearId"] = this.yearId;
    data["month"] = this.month;
    data["quarter"] = this.quarter;
    data["year"] = this.year;
    data["isPipeline"] = this.isPipeline;
    data["isUnderContract"] = this.isUnderContract;
    return data;
  }
}

export interface IAggregateDataSummary {
  totalCount?: number;
  totalAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;
  year?: number;
  isPipeline?: boolean;
  isUnderContract?: boolean;
}

export enum AggregationTypes {
  Total = 0,
  Average = 1,
}

export class FinancialCategoryDataSummary implements IFinancialCategoryDataSummary {
  totalCount?: number;
  totalAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;

  constructor(data?: IFinancialCategoryDataSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalCount = _data["totalCount"];
      this.totalAmount = _data["totalAmount"];
      this.yearId = _data["yearId"];
      this.month = _data["month"];
      this.quarter = _data["quarter"];
    }
  }

  static fromJS(data: any): FinancialCategoryDataSummary {
    data = typeof data === "object" ? data : {};
    let result = new FinancialCategoryDataSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalCount"] = this.totalCount;
    data["totalAmount"] = this.totalAmount;
    data["yearId"] = this.yearId;
    data["month"] = this.month;
    data["quarter"] = this.quarter;
    return data;
  }
}

export interface IFinancialCategoryDataSummary {
  totalCount?: number;
  totalAmount?: number;
  yearId?: number | undefined;
  month?: number | undefined;
  quarter?: number | undefined;
}

export enum FinancialCategoryEnum {
  Commission = 0,
  Gci = 1,
  EffectiveGci = 2,
  BrokerageTotal = 3,
  NetCommissionIncome = 4,
  NetIncome = 5,
  NetIncomePercent = 6,
}

export class BusinessPlanningDataResponse implements IBusinessPlanningDataResponse {
  evaluationYears?: number[];
  forecastYear?: number;
  categories?: BusinessPlanningCategoryData[];
  monthlyTrend?: BusinessPlanningMonthlyTrend[];
  currentYearMonthlyTrend?: BusinessPlanningMonthlyTrend[] | undefined;
  ytdData?: BusinessPlanningYtdData[] | undefined;
  underContractGci?: number | undefined;
  underContractLastMonth?: number | undefined;
  currentGciWithUnderContract?: number | undefined;

  constructor(data?: IBusinessPlanningDataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["evaluationYears"])) {
        this.evaluationYears = [] as any;
        for (let item of _data["evaluationYears"])
          this.evaluationYears!.push(item);
      }
      this.forecastYear = _data["forecastYear"];
      if (Array.isArray(_data["categories"])) {
        this.categories = [] as any;
        for (let item of _data["categories"])
          this.categories!.push(BusinessPlanningCategoryData.fromJS(item));
      }
      if (Array.isArray(_data["monthlyTrend"])) {
        this.monthlyTrend = [] as any;
        for (let item of _data["monthlyTrend"])
          this.monthlyTrend!.push(BusinessPlanningMonthlyTrend.fromJS(item));
      }
      if (Array.isArray(_data["currentYearMonthlyTrend"])) {
        this.currentYearMonthlyTrend = [] as any;
        for (let item of _data["currentYearMonthlyTrend"])
          this.currentYearMonthlyTrend!.push(
            BusinessPlanningMonthlyTrend.fromJS(item),
          );
      }
      if (Array.isArray(_data["ytdData"])) {
        this.ytdData = [] as any;
        for (let item of _data["ytdData"])
          this.ytdData!.push(BusinessPlanningYtdData.fromJS(item));
      }
      this.underContractGci = _data["underContractGci"];
      this.underContractLastMonth = _data["underContractLastMonth"];
      this.currentGciWithUnderContract = _data["currentGciWithUnderContract"];
    }
  }

  static fromJS(data: any): BusinessPlanningDataResponse {
    data = typeof data === "object" ? data : {};
    let result = new BusinessPlanningDataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.evaluationYears)) {
      data["evaluationYears"] = [];
      for (let item of this.evaluationYears) data["evaluationYears"].push(item);
    }
    data["forecastYear"] = this.forecastYear;
    if (Array.isArray(this.categories)) {
      data["categories"] = [];
      for (let item of this.categories)
        data["categories"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.monthlyTrend)) {
      data["monthlyTrend"] = [];
      for (let item of this.monthlyTrend)
        data["monthlyTrend"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.currentYearMonthlyTrend)) {
      data["currentYearMonthlyTrend"] = [];
      for (let item of this.currentYearMonthlyTrend)
        data["currentYearMonthlyTrend"].push(
          item ? item.toJSON() : (undefined as any),
        );
    }
    if (Array.isArray(this.ytdData)) {
      data["ytdData"] = [];
      for (let item of this.ytdData)
        data["ytdData"].push(item ? item.toJSON() : (undefined as any));
    }
    data["underContractGci"] = this.underContractGci;
    data["underContractLastMonth"] = this.underContractLastMonth;
    data["currentGciWithUnderContract"] = this.currentGciWithUnderContract;
    return data;
  }
}

export interface IBusinessPlanningDataResponse {
  evaluationYears?: number[];
  forecastYear?: number;
  categories?: BusinessPlanningCategoryData[];
  monthlyTrend?: BusinessPlanningMonthlyTrend[];
  currentYearMonthlyTrend?: BusinessPlanningMonthlyTrend[] | undefined;
  ytdData?: BusinessPlanningYtdData[] | undefined;
  underContractGci?: number | undefined;
  underContractLastMonth?: number | undefined;
  currentGciWithUnderContract?: number | undefined;
}

export class BusinessPlanningCategoryData implements IBusinessPlanningCategoryData {
  category?: string;
  items?: BusinessPlanningCategoryItem[];
  totalGci?: number;
  totalEffectiveGci?: number;
  totalCount?: number;

  constructor(data?: IBusinessPlanningCategoryData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.category = _data["category"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(BusinessPlanningCategoryItem.fromJS(item));
      }
      this.totalGci = _data["totalGci"];
      this.totalEffectiveGci = _data["totalEffectiveGci"];
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): BusinessPlanningCategoryData {
    data = typeof data === "object" ? data : {};
    let result = new BusinessPlanningCategoryData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["category"] = this.category;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : (undefined as any));
    }
    data["totalGci"] = this.totalGci;
    data["totalEffectiveGci"] = this.totalEffectiveGci;
    data["totalCount"] = this.totalCount;
    return data;
  }
}

export interface IBusinessPlanningCategoryData {
  category?: string;
  items?: BusinessPlanningCategoryItem[];
  totalGci?: number;
  totalEffectiveGci?: number;
  totalCount?: number;
}

export class BusinessPlanningCategoryItem implements IBusinessPlanningCategoryItem {
  id?: string;
  name?: string;
  totalGci?: number;
  totalEffectiveGci?: number;
  totalCount?: number;
  totalPrice?: number;
  avgPrice?: number;
  avgCommissionPct?: number;
  isSb?: boolean;

  constructor(data?: IBusinessPlanningCategoryItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.totalGci = _data["totalGci"];
      this.totalEffectiveGci = _data["totalEffectiveGci"];
      this.totalCount = _data["totalCount"];
      this.totalPrice = _data["totalPrice"];
      this.avgPrice = _data["avgPrice"];
      this.avgCommissionPct = _data["avgCommissionPct"];
      this.isSb = _data["isSb"];
    }
  }

  static fromJS(data: any): BusinessPlanningCategoryItem {
    data = typeof data === "object" ? data : {};
    let result = new BusinessPlanningCategoryItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["totalGci"] = this.totalGci;
    data["totalEffectiveGci"] = this.totalEffectiveGci;
    data["totalCount"] = this.totalCount;
    data["totalPrice"] = this.totalPrice;
    data["avgPrice"] = this.avgPrice;
    data["avgCommissionPct"] = this.avgCommissionPct;
    data["isSb"] = this.isSb;
    return data;
  }
}

export interface IBusinessPlanningCategoryItem {
  id?: string;
  name?: string;
  totalGci?: number;
  totalEffectiveGci?: number;
  totalCount?: number;
  totalPrice?: number;
  avgPrice?: number;
  avgCommissionPct?: number;
  isSb?: boolean;
}

export class BusinessPlanningMonthlyTrend implements IBusinessPlanningMonthlyTrend {
  month?: number;
  cumulativeGci?: number;
  yearId?: number | undefined;

  constructor(data?: IBusinessPlanningMonthlyTrend) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.month = _data["month"];
      this.cumulativeGci = _data["cumulativeGci"];
      this.yearId = _data["yearId"];
    }
  }

  static fromJS(data: any): BusinessPlanningMonthlyTrend {
    data = typeof data === "object" ? data : {};
    let result = new BusinessPlanningMonthlyTrend();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["month"] = this.month;
    data["cumulativeGci"] = this.cumulativeGci;
    data["yearId"] = this.yearId;
    return data;
  }
}

export interface IBusinessPlanningMonthlyTrend {
  month?: number;
  cumulativeGci?: number;
  yearId?: number | undefined;
}

export class BusinessPlanningYtdData implements IBusinessPlanningYtdData {
  category?: string;
  items?: BusinessPlanningYtdItem[];

  constructor(data?: IBusinessPlanningYtdData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.category = _data["category"];
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(BusinessPlanningYtdItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BusinessPlanningYtdData {
    data = typeof data === "object" ? data : {};
    let result = new BusinessPlanningYtdData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["category"] = this.category;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IBusinessPlanningYtdData {
  category?: string;
  items?: BusinessPlanningYtdItem[];
}

export class BusinessPlanningYtdItem implements IBusinessPlanningYtdItem {
  id?: string;
  name?: string;
  transactionCount?: number;

  constructor(data?: IBusinessPlanningYtdItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.transactionCount = _data["transactionCount"];
    }
  }

  static fromJS(data: any): BusinessPlanningYtdItem {
    data = typeof data === "object" ? data : {};
    let result = new BusinessPlanningYtdItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["transactionCount"] = this.transactionCount;
    return data;
  }
}

export interface IBusinessPlanningYtdItem {
  id?: string;
  name?: string;
  transactionCount?: number;
}

export class BusinessZonesResponse implements IBusinessZonesResponse {
  evaluationYears?: number[];
  greenThreshold?: number;
  yellowThreshold?: number;
  greenZone?: BusinessZoneData;
  yellowZone?: BusinessZoneData;
  redZone?: BusinessZoneData;

  constructor(data?: IBusinessZonesResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["evaluationYears"])) {
        this.evaluationYears = [] as any;
        for (let item of _data["evaluationYears"])
          this.evaluationYears!.push(item);
      }
      this.greenThreshold = _data["greenThreshold"];
      this.yellowThreshold = _data["yellowThreshold"];
      this.greenZone = _data["greenZone"]
        ? BusinessZoneData.fromJS(_data["greenZone"])
        : (undefined as any);
      this.yellowZone = _data["yellowZone"]
        ? BusinessZoneData.fromJS(_data["yellowZone"])
        : (undefined as any);
      this.redZone = _data["redZone"]
        ? BusinessZoneData.fromJS(_data["redZone"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): BusinessZonesResponse {
    data = typeof data === "object" ? data : {};
    let result = new BusinessZonesResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.evaluationYears)) {
      data["evaluationYears"] = [];
      for (let item of this.evaluationYears) data["evaluationYears"].push(item);
    }
    data["greenThreshold"] = this.greenThreshold;
    data["yellowThreshold"] = this.yellowThreshold;
    data["greenZone"] = this.greenZone
      ? this.greenZone.toJSON()
      : (undefined as any);
    data["yellowZone"] = this.yellowZone
      ? this.yellowZone.toJSON()
      : (undefined as any);
    data["redZone"] = this.redZone ? this.redZone.toJSON() : (undefined as any);
    return data;
  }
}

export interface IBusinessZonesResponse {
  evaluationYears?: number[];
  greenThreshold?: number;
  yellowThreshold?: number;
  greenZone?: BusinessZoneData;
  yellowZone?: BusinessZoneData;
  redZone?: BusinessZoneData;
}

export class BusinessZoneData implements IBusinessZoneData {
  zone?: string;
  categories?: BusinessZoneCategoryData[];

  constructor(data?: IBusinessZoneData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.zone = _data["zone"];
      if (Array.isArray(_data["categories"])) {
        this.categories = [] as any;
        for (let item of _data["categories"])
          this.categories!.push(BusinessZoneCategoryData.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BusinessZoneData {
    data = typeof data === "object" ? data : {};
    let result = new BusinessZoneData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["zone"] = this.zone;
    if (Array.isArray(this.categories)) {
      data["categories"] = [];
      for (let item of this.categories)
        data["categories"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IBusinessZoneData {
  zone?: string;
  categories?: BusinessZoneCategoryData[];
}

export class BusinessZoneCategoryData implements IBusinessZoneCategoryData {
  category?: string;
  variables?: BusinessZoneVariable[];

  constructor(data?: IBusinessZoneCategoryData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.category = _data["category"];
      if (Array.isArray(_data["variables"])) {
        this.variables = [] as any;
        for (let item of _data["variables"])
          this.variables!.push(BusinessZoneVariable.fromJS(item));
      }
    }
  }

  static fromJS(data: any): BusinessZoneCategoryData {
    data = typeof data === "object" ? data : {};
    let result = new BusinessZoneCategoryData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["category"] = this.category;
    if (Array.isArray(this.variables)) {
      data["variables"] = [];
      for (let item of this.variables)
        data["variables"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IBusinessZoneCategoryData {
  category?: string;
  variables?: BusinessZoneVariable[];
}

export class BusinessZoneVariable implements IBusinessZoneVariable {
  id?: string;
  name?: string;
  units?: number;
  volume?: number;
  netIncome?: number;
  unitsPercent?: number;
  volumePercent?: number;
  netIncomePercent?: number;

  constructor(data?: IBusinessZoneVariable) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.units = _data["units"];
      this.volume = _data["volume"];
      this.netIncome = _data["netIncome"];
      this.unitsPercent = _data["unitsPercent"];
      this.volumePercent = _data["volumePercent"];
      this.netIncomePercent = _data["netIncomePercent"];
    }
  }

  static fromJS(data: any): BusinessZoneVariable {
    data = typeof data === "object" ? data : {};
    let result = new BusinessZoneVariable();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["units"] = this.units;
    data["volume"] = this.volume;
    data["netIncome"] = this.netIncome;
    data["unitsPercent"] = this.unitsPercent;
    data["volumePercent"] = this.volumePercent;
    data["netIncomePercent"] = this.netIncomePercent;
    return data;
  }
}

export interface IBusinessZoneVariable {
  id?: string;
  name?: string;
  units?: number;
  volume?: number;
  netIncome?: number;
  unitsPercent?: number;
  volumePercent?: number;
  netIncomePercent?: number;
}

export class BusinessZonesSettings implements IBusinessZonesSettings {
  greenThreshold?: number;
  yellowThreshold?: number;
  evaluationYears?: string;
  zoneMetric?: string;

  constructor(data?: IBusinessZonesSettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.greenThreshold = _data["greenThreshold"];
      this.yellowThreshold = _data["yellowThreshold"];
      this.evaluationYears = _data["evaluationYears"];
      this.zoneMetric = _data["zoneMetric"];
    }
  }

  static fromJS(data: any): BusinessZonesSettings {
    data = typeof data === "object" ? data : {};
    let result = new BusinessZonesSettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["greenThreshold"] = this.greenThreshold;
    data["yellowThreshold"] = this.yellowThreshold;
    data["evaluationYears"] = this.evaluationYears;
    data["zoneMetric"] = this.zoneMetric;
    return data;
  }
}

export interface IBusinessZonesSettings {
  greenThreshold?: number;
  yellowThreshold?: number;
  evaluationYears?: string;
  zoneMetric?: string;
}

export class ChatResponse implements IChatResponse {
  answer?: string;
  sessionId?: string;
  messageCount?: number;
  dailyMessageCount?: number;
  dailyLimit?: number;
  isLimitReached?: boolean;

  constructor(data?: IChatResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data["answer"];
      this.sessionId = _data["sessionId"];
      this.messageCount = _data["messageCount"];
      this.dailyMessageCount = _data["dailyMessageCount"];
      this.dailyLimit = _data["dailyLimit"];
      this.isLimitReached = _data["isLimitReached"];
    }
  }

  static fromJS(data: any): ChatResponse {
    data = typeof data === "object" ? data : {};
    let result = new ChatResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["answer"] = this.answer;
    data["sessionId"] = this.sessionId;
    data["messageCount"] = this.messageCount;
    data["dailyMessageCount"] = this.dailyMessageCount;
    data["dailyLimit"] = this.dailyLimit;
    data["isLimitReached"] = this.isLimitReached;
    return data;
  }
}

export interface IChatResponse {
  answer?: string;
  sessionId?: string;
  messageCount?: number;
  dailyMessageCount?: number;
  dailyLimit?: number;
  isLimitReached?: boolean;
}

export class ChatRequest implements IChatRequest {
  question!: string;
  sessionId?: string | undefined;

  constructor(data?: IChatRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.question = _data["question"];
      this.sessionId = _data["sessionId"];
    }
  }

  static fromJS(data: any): ChatRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChatRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["question"] = this.question;
    data["sessionId"] = this.sessionId;
    return data;
  }
}

export interface IChatRequest {
  question: string;
  sessionId?: string | undefined;
}

export class ConversationSession implements IConversationSession {
  sessionId?: string;
  userId!: string;
  createdAt?: dayjs.Dayjs;
  lastActivity?: dayjs.Dayjs;
  isActive?: boolean;
  messages?: ConversationMessage[];

  constructor(data?: IConversationSession) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sessionId = _data["sessionId"];
      this.userId = _data["userId"];
      this.createdAt = _data["createdAt"]
        ? dayjs(_data["createdAt"].toString())
        : (undefined as any);
      this.lastActivity = _data["lastActivity"]
        ? dayjs(_data["lastActivity"].toString())
        : (undefined as any);
      this.isActive = _data["isActive"];
      if (Array.isArray(_data["messages"])) {
        this.messages = [] as any;
        for (let item of _data["messages"])
          this.messages!.push(ConversationMessage.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ConversationSession {
    data = typeof data === "object" ? data : {};
    let result = new ConversationSession();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["sessionId"] = this.sessionId;
    data["userId"] = this.userId;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : (undefined as any);
    data["lastActivity"] = this.lastActivity
      ? this.lastActivity.toISOString()
      : (undefined as any);
    data["isActive"] = this.isActive;
    if (Array.isArray(this.messages)) {
      data["messages"] = [];
      for (let item of this.messages)
        data["messages"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IConversationSession {
  sessionId?: string;
  userId: string;
  createdAt?: dayjs.Dayjs;
  lastActivity?: dayjs.Dayjs;
  isActive?: boolean;
  messages?: ConversationMessage[];
}

export class ConversationMessage implements IConversationMessage {
  messageId?: number;
  sessionId!: string;
  role!: string;
  content!: string;
  createdAt?: dayjs.Dayjs;
  tokensUsed?: number | undefined;
  session?: ConversationSession;

  constructor(data?: IConversationMessage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.messageId = _data["messageId"];
      this.sessionId = _data["sessionId"];
      this.role = _data["role"];
      this.content = _data["content"];
      this.createdAt = _data["createdAt"]
        ? dayjs(_data["createdAt"].toString())
        : (undefined as any);
      this.tokensUsed = _data["tokensUsed"];
      this.session = _data["session"]
        ? ConversationSession.fromJS(_data["session"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): ConversationMessage {
    data = typeof data === "object" ? data : {};
    let result = new ConversationMessage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["messageId"] = this.messageId;
    data["sessionId"] = this.sessionId;
    data["role"] = this.role;
    data["content"] = this.content;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : (undefined as any);
    data["tokensUsed"] = this.tokensUsed;
    data["session"] = this.session ? this.session.toJSON() : (undefined as any);
    return data;
  }
}

export interface IConversationMessage {
  messageId?: number;
  sessionId: string;
  role: string;
  content: string;
  createdAt?: dayjs.Dayjs;
  tokensUsed?: number | undefined;
  session?: ConversationSession;
}

export class JsonExplanationResponse implements IJsonExplanationResponse {
  explanation?: string;
  dailyMessageCount?: number;
  dailyLimit?: number;
  isLimitReached?: boolean;

  constructor(data?: IJsonExplanationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.explanation = _data["explanation"];
      this.dailyMessageCount = _data["dailyMessageCount"];
      this.dailyLimit = _data["dailyLimit"];
      this.isLimitReached = _data["isLimitReached"];
    }
  }

  static fromJS(data: any): JsonExplanationResponse {
    data = typeof data === "object" ? data : {};
    let result = new JsonExplanationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["explanation"] = this.explanation;
    data["dailyMessageCount"] = this.dailyMessageCount;
    data["dailyLimit"] = this.dailyLimit;
    data["isLimitReached"] = this.isLimitReached;
    return data;
  }
}

export interface IJsonExplanationResponse {
  explanation?: string;
  dailyMessageCount?: number;
  dailyLimit?: number;
  isLimitReached?: boolean;
}

export class JsonExplanationRequest implements IJsonExplanationRequest {
  jsonData!: any;
  analysisType!: string;
  mode!: string;
  timePeriod!: string;
  selectedYearText!: string;
  category?: string | undefined;
  variableName?: string | undefined;
  variableNames?: string | undefined;
  aggregationType?: string | undefined;
  context?: string | undefined;

  constructor(data?: IJsonExplanationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.jsonData = _data["jsonData"];
      this.analysisType = _data["analysisType"];
      this.mode = _data["mode"];
      this.timePeriod = _data["timePeriod"];
      this.selectedYearText = _data["selectedYearText"];
      this.category = _data["category"];
      this.variableName = _data["variableName"];
      this.variableNames = _data["variableNames"];
      this.aggregationType = _data["aggregationType"];
      this.context = _data["context"];
    }
  }

  static fromJS(data: any): JsonExplanationRequest {
    data = typeof data === "object" ? data : {};
    let result = new JsonExplanationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["jsonData"] = this.jsonData;
    data["analysisType"] = this.analysisType;
    data["mode"] = this.mode;
    data["timePeriod"] = this.timePeriod;
    data["selectedYearText"] = this.selectedYearText;
    data["category"] = this.category;
    data["variableName"] = this.variableName;
    data["variableNames"] = this.variableNames;
    data["aggregationType"] = this.aggregationType;
    data["context"] = this.context;
    return data;
  }
}

export interface IJsonExplanationRequest {
  jsonData: any;
  analysisType: string;
  mode: string;
  timePeriod: string;
  selectedYearText: string;
  category?: string | undefined;
  variableName?: string | undefined;
  variableNames?: string | undefined;
  aggregationType?: string | undefined;
  context?: string | undefined;
}

export class CommonData implements ICommonData {
  categories?: FormCategory[];

  constructor(data?: ICommonData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["categories"])) {
        this.categories = [] as any;
        for (let item of _data["categories"])
          this.categories!.push(FormCategory.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CommonData {
    data = typeof data === "object" ? data : {};
    let result = new CommonData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.categories)) {
      data["categories"] = [];
      for (let item of this.categories)
        data["categories"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICommonData {
  categories?: FormCategory[];
}

export class FormCategory implements IFormCategory {
  id?: number;
  name?: string;
  internalName?: string;

  constructor(data?: IFormCategory) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.internalName = _data["internalName"];
    }
  }

  static fromJS(data: any): FormCategory {
    data = typeof data === "object" ? data : {};
    let result = new FormCategory();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["internalName"] = this.internalName;
    return data;
  }
}

export interface IFormCategory {
  id?: number;
  name?: string;
  internalName?: string;
}

export class CustomUserData implements ICustomUserData {
  coAgents?: LookupItem[];
  specialGroups?: LookupItem[];
  specialTags?: LookupItem[];
  areas?: LookupItem[];
  reasons?: LookupItem[];
  sources?: TransactionSource[];
  transactionTypes?: TransactionType[];
  referralOutTypes?: LookupItem[];
  preferredAreaType?: AreaTypeEnum | undefined;

  constructor(data?: ICustomUserData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["coAgents"])) {
        this.coAgents = [] as any;
        for (let item of _data["coAgents"])
          this.coAgents!.push(LookupItem.fromJS(item));
      }
      if (Array.isArray(_data["specialGroups"])) {
        this.specialGroups = [] as any;
        for (let item of _data["specialGroups"])
          this.specialGroups!.push(LookupItem.fromJS(item));
      }
      if (Array.isArray(_data["specialTags"])) {
        this.specialTags = [] as any;
        for (let item of _data["specialTags"])
          this.specialTags!.push(LookupItem.fromJS(item));
      }
      if (Array.isArray(_data["areas"])) {
        this.areas = [] as any;
        for (let item of _data["areas"])
          this.areas!.push(LookupItem.fromJS(item));
      }
      if (Array.isArray(_data["reasons"])) {
        this.reasons = [] as any;
        for (let item of _data["reasons"])
          this.reasons!.push(LookupItem.fromJS(item));
      }
      if (Array.isArray(_data["sources"])) {
        this.sources = [] as any;
        for (let item of _data["sources"])
          this.sources!.push(TransactionSource.fromJS(item));
      }
      if (Array.isArray(_data["transactionTypes"])) {
        this.transactionTypes = [] as any;
        for (let item of _data["transactionTypes"])
          this.transactionTypes!.push(TransactionType.fromJS(item));
      }
      if (Array.isArray(_data["referralOutTypes"])) {
        this.referralOutTypes = [] as any;
        for (let item of _data["referralOutTypes"])
          this.referralOutTypes!.push(LookupItem.fromJS(item));
      }
      this.preferredAreaType = _data["preferredAreaType"];
    }
  }

  static fromJS(data: any): CustomUserData {
    data = typeof data === "object" ? data : {};
    let result = new CustomUserData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.coAgents)) {
      data["coAgents"] = [];
      for (let item of this.coAgents)
        data["coAgents"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.specialGroups)) {
      data["specialGroups"] = [];
      for (let item of this.specialGroups)
        data["specialGroups"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.specialTags)) {
      data["specialTags"] = [];
      for (let item of this.specialTags)
        data["specialTags"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.areas)) {
      data["areas"] = [];
      for (let item of this.areas)
        data["areas"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.reasons)) {
      data["reasons"] = [];
      for (let item of this.reasons)
        data["reasons"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.sources)) {
      data["sources"] = [];
      for (let item of this.sources)
        data["sources"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.transactionTypes)) {
      data["transactionTypes"] = [];
      for (let item of this.transactionTypes)
        data["transactionTypes"].push(
          item ? item.toJSON() : (undefined as any),
        );
    }
    if (Array.isArray(this.referralOutTypes)) {
      data["referralOutTypes"] = [];
      for (let item of this.referralOutTypes)
        data["referralOutTypes"].push(
          item ? item.toJSON() : (undefined as any),
        );
    }
    data["preferredAreaType"] = this.preferredAreaType;
    return data;
  }
}

export interface ICustomUserData {
  coAgents?: LookupItem[];
  specialGroups?: LookupItem[];
  specialTags?: LookupItem[];
  areas?: LookupItem[];
  reasons?: LookupItem[];
  sources?: TransactionSource[];
  transactionTypes?: TransactionType[];
  referralOutTypes?: LookupItem[];
  preferredAreaType?: AreaTypeEnum | undefined;
}

export class LookupItem implements ILookupItem {
  id?: number;
  name?: string;
  system?: boolean | undefined;
  deleted?: boolean | undefined;

  constructor(data?: ILookupItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.system = _data["system"];
      this.deleted = _data["deleted"];
    }
  }

  static fromJS(data: any): LookupItem {
    data = typeof data === "object" ? data : {};
    let result = new LookupItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["system"] = this.system;
    data["deleted"] = this.deleted;
    return data;
  }
}

export interface ILookupItem {
  id?: number;
  name?: string;
  system?: boolean | undefined;
  deleted?: boolean | undefined;
}

export class TransactionSource implements ITransactionSource {
  id?: number;
  name?: string;
  showSoiReferrer?: boolean;
  showAgentReferrer?: boolean;
  showVendorReferrer?: boolean;
  system?: boolean;
  deleted?: boolean;

  constructor(data?: ITransactionSource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.showSoiReferrer = _data["showSoiReferrer"];
      this.showAgentReferrer = _data["showAgentReferrer"];
      this.showVendorReferrer = _data["showVendorReferrer"];
      this.system = _data["system"];
      this.deleted = _data["deleted"];
    }
  }

  static fromJS(data: any): TransactionSource {
    data = typeof data === "object" ? data : {};
    let result = new TransactionSource();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["showSoiReferrer"] = this.showSoiReferrer;
    data["showAgentReferrer"] = this.showAgentReferrer;
    data["showVendorReferrer"] = this.showVendorReferrer;
    data["system"] = this.system;
    data["deleted"] = this.deleted;
    return data;
  }
}

export interface ITransactionSource {
  id?: number;
  name?: string;
  showSoiReferrer?: boolean;
  showAgentReferrer?: boolean;
  showVendorReferrer?: boolean;
  system?: boolean;
  deleted?: boolean;
}

export class TransactionType implements ITransactionType {
  id?: number;
  name?: string;
  isMonthlyRent?: boolean;
  showReferralOut?: boolean;
  system?: boolean;
  deleted?: boolean;
  isSb?: boolean;

  constructor(data?: ITransactionType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.isMonthlyRent = _data["isMonthlyRent"];
      this.showReferralOut = _data["showReferralOut"];
      this.system = _data["system"];
      this.deleted = _data["deleted"];
      this.isSb = _data["isSb"];
    }
  }

  static fromJS(data: any): TransactionType {
    data = typeof data === "object" ? data : {};
    let result = new TransactionType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["isMonthlyRent"] = this.isMonthlyRent;
    data["showReferralOut"] = this.showReferralOut;
    data["system"] = this.system;
    data["deleted"] = this.deleted;
    data["isSb"] = this.isSb;
    return data;
  }
}

export interface ITransactionType {
  id?: number;
  name?: string;
  isMonthlyRent?: boolean;
  showReferralOut?: boolean;
  system?: boolean;
  deleted?: boolean;
  isSb?: boolean;
}

export enum AreaTypeEnum {
  State = 0,
  County = 2,
  Custom = 3,
}

export class HttpValidationProblemDetails
  extends ProblemDetails
  implements IHttpValidationProblemDetails
{
  errors?: { [key: string]: string[] };

  [key: string]: any;

  constructor(data?: IHttpValidationProblemDetails) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (this.errors as any)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
    }
  }

  static override fromJS(data: any): HttpValidationProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new HttpValidationProblemDetails();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (data["errors"] as any)[key] = (this.errors as any)[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
  errors?: { [key: string]: string[] };

  [key: string]: any;
}

export class ValidationProblemDetails
  extends HttpValidationProblemDetails
  implements IValidationProblemDetails
{
  errors?: { [key: string]: string[] };

  [key: string]: any;

  constructor(data?: IValidationProblemDetails) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      if (_data["errors"]) {
        this.errors = {} as any;
        for (let key in _data["errors"]) {
          if (_data["errors"].hasOwnProperty(key))
            (this.errors as any)![key] =
              _data["errors"][key] !== undefined ? _data["errors"][key] : [];
        }
      }
    }
  }

  static override fromJS(data: any): ValidationProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ValidationProblemDetails();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    if (this.errors) {
      data["errors"] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (data["errors"] as any)[key] = (this.errors as any)[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
  errors?: { [key: string]: string[] };

  [key: string]: any;
}

export enum DropDownCategoryEnum {
  Reason = 0,
  TransactionType = 1,
  Source = 2,
  Client = 3,
  Area = 4,
  SpecialGroup = 5,
  SpecialTag = 6,
  CoAgent = 7,
  SoiReferrer = 8,
  AgentReferrer = 9,
  VendorReferrer = 10,
  AgentReferred = 11,
  ReferralOutType = 12,
  Contact = 13,
  Vendor = 14,
}

export class PagedResultOfLookupItemSimple implements IPagedResultOfLookupItemSimple {
  result?: LookupItemSimple[];
  totalCount?: number;

  constructor(data?: IPagedResultOfLookupItemSimple) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result!.push(LookupItemSimple.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): PagedResultOfLookupItemSimple {
    data = typeof data === "object" ? data : {};
    let result = new PagedResultOfLookupItemSimple();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item ? item.toJSON() : (undefined as any));
    }
    data["totalCount"] = this.totalCount;
    return data;
  }
}

export interface IPagedResultOfLookupItemSimple {
  result?: LookupItemSimple[];
  totalCount?: number;
}

export class LookupItemSimple implements ILookupItemSimple {
  id?: number;
  name?: string;

  constructor(data?: ILookupItemSimple) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): LookupItemSimple {
    data = typeof data === "object" ? data : {};
    let result = new LookupItemSimple();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface ILookupItemSimple {
  id?: number;
  name?: string;
}

export enum ReferrerTypeEnum {
  Agent = 0,
  Soi = 1,
  Vendor = 2,
  ReferredOut = 3,
}

export class UpdateCategoryVariableHttpRequest implements IUpdateCategoryVariableHttpRequest {
  dropDownCategory?: DropDownCategoryEnum;
  id?: number;
  name?: string;

  constructor(data?: IUpdateCategoryVariableHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dropDownCategory = _data["dropDownCategory"];
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): UpdateCategoryVariableHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateCategoryVariableHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dropDownCategory"] = this.dropDownCategory;
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IUpdateCategoryVariableHttpRequest {
  dropDownCategory?: DropDownCategoryEnum;
  id?: number;
  name?: string;
}

export class DeleteCategoryVariableHttpRequest implements IDeleteCategoryVariableHttpRequest {
  dropDownCategory?: DropDownCategoryEnum;
  id?: number;

  constructor(data?: IDeleteCategoryVariableHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dropDownCategory = _data["dropDownCategory"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): DeleteCategoryVariableHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new DeleteCategoryVariableHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dropDownCategory"] = this.dropDownCategory;
    data["id"] = this.id;
    return data;
  }
}

export interface IDeleteCategoryVariableHttpRequest {
  dropDownCategory?: DropDownCategoryEnum;
  id?: number;
}

export class BrokerageAnniversary implements IBrokerageAnniversary {
  brokerageAnniversaryId?: number;
  userId?: string;
  name?: string;
  anniversaryDate?: dayjs.Dayjs;
  commissionPercentage?: number;
  flatCommissionFee?: number;
  brokerageSplit?: number;
  splitCap?: number | undefined;
  additionalChargePercentage?: number;
  additionalChargeCap?: number | undefined;
  flatTransactionalFees?: number;
  referralOutFeeReceived?: number | undefined;
  referralFeePaid?: number | undefined;
  rentalCommissionPercentage?: number | undefined;
  createdOn?: dayjs.Dayjs;
  createdBy?: string;
  updatedOn?: dayjs.Dayjs | undefined;
  updatedBy?: string | undefined;
  lastRun?: dayjs.Dayjs | undefined;

  constructor(data?: IBrokerageAnniversary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.brokerageAnniversaryId = _data["brokerageAnniversaryId"];
      this.userId = _data["userId"];
      this.name = _data["name"];
      this.anniversaryDate = _data["anniversaryDate"]
        ? dayjs(_data["anniversaryDate"].toString())
        : (undefined as any);
      this.commissionPercentage = _data["commissionPercentage"];
      this.flatCommissionFee = _data["flatCommissionFee"];
      this.brokerageSplit = _data["brokerageSplit"];
      this.splitCap = _data["splitCap"];
      this.additionalChargePercentage = _data["additionalChargePercentage"];
      this.additionalChargeCap = _data["additionalChargeCap"];
      this.flatTransactionalFees = _data["flatTransactionalFees"];
      this.referralOutFeeReceived = _data["referralOutFeeReceived"];
      this.referralFeePaid = _data["referralFeePaid"];
      this.rentalCommissionPercentage = _data["rentalCommissionPercentage"];
      this.createdOn = _data["createdOn"]
        ? dayjs(_data["createdOn"].toString())
        : (undefined as any);
      this.createdBy = _data["createdBy"];
      this.updatedOn = _data["updatedOn"]
        ? dayjs(_data["updatedOn"].toString())
        : (undefined as any);
      this.updatedBy = _data["updatedBy"];
      this.lastRun = _data["lastRun"]
        ? dayjs(_data["lastRun"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): BrokerageAnniversary {
    data = typeof data === "object" ? data : {};
    let result = new BrokerageAnniversary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["brokerageAnniversaryId"] = this.brokerageAnniversaryId;
    data["userId"] = this.userId;
    data["name"] = this.name;
    data["anniversaryDate"] = this.anniversaryDate
      ? this.anniversaryDate.toISOString()
      : (undefined as any);
    data["commissionPercentage"] = this.commissionPercentage;
    data["flatCommissionFee"] = this.flatCommissionFee;
    data["brokerageSplit"] = this.brokerageSplit;
    data["splitCap"] = this.splitCap;
    data["additionalChargePercentage"] = this.additionalChargePercentage;
    data["additionalChargeCap"] = this.additionalChargeCap;
    data["flatTransactionalFees"] = this.flatTransactionalFees;
    data["referralOutFeeReceived"] = this.referralOutFeeReceived;
    data["referralFeePaid"] = this.referralFeePaid;
    data["rentalCommissionPercentage"] = this.rentalCommissionPercentage;
    data["createdOn"] = this.createdOn
      ? this.createdOn.toISOString()
      : (undefined as any);
    data["createdBy"] = this.createdBy;
    data["updatedOn"] = this.updatedOn
      ? this.updatedOn.toISOString()
      : (undefined as any);
    data["updatedBy"] = this.updatedBy;
    data["lastRun"] = this.lastRun
      ? this.lastRun.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IBrokerageAnniversary {
  brokerageAnniversaryId?: number;
  userId?: string;
  name?: string;
  anniversaryDate?: dayjs.Dayjs;
  commissionPercentage?: number;
  flatCommissionFee?: number;
  brokerageSplit?: number;
  splitCap?: number | undefined;
  additionalChargePercentage?: number;
  additionalChargeCap?: number | undefined;
  flatTransactionalFees?: number;
  referralOutFeeReceived?: number | undefined;
  referralFeePaid?: number | undefined;
  rentalCommissionPercentage?: number | undefined;
  createdOn?: dayjs.Dayjs;
  createdBy?: string;
  updatedOn?: dayjs.Dayjs | undefined;
  updatedBy?: string | undefined;
  lastRun?: dayjs.Dayjs | undefined;
}

export class CreateBrokerageAnniversaryRequest implements ICreateBrokerageAnniversaryRequest {
  name?: string;
  anniversaryDate?: dayjs.Dayjs;
  commissionPercentage?: number;
  flatCommissionFee?: number;
  brokerageSplit?: number;
  splitCap?: number | undefined;
  additionalChargePercentage?: number;
  additionalChargeCap?: number | undefined;
  flatTransactionalFees?: number;
  referralOutFeeReceived?: number | undefined;
  referralFeePaid?: number | undefined;
  rentalCommissionPercentage?: number | undefined;

  constructor(data?: ICreateBrokerageAnniversaryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.anniversaryDate = _data["anniversaryDate"]
        ? dayjs(_data["anniversaryDate"].toString())
        : (undefined as any);
      this.commissionPercentage = _data["commissionPercentage"];
      this.flatCommissionFee = _data["flatCommissionFee"];
      this.brokerageSplit = _data["brokerageSplit"];
      this.splitCap = _data["splitCap"];
      this.additionalChargePercentage = _data["additionalChargePercentage"];
      this.additionalChargeCap = _data["additionalChargeCap"];
      this.flatTransactionalFees = _data["flatTransactionalFees"];
      this.referralOutFeeReceived = _data["referralOutFeeReceived"];
      this.referralFeePaid = _data["referralFeePaid"];
      this.rentalCommissionPercentage = _data["rentalCommissionPercentage"];
    }
  }

  static fromJS(data: any): CreateBrokerageAnniversaryRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateBrokerageAnniversaryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["anniversaryDate"] = this.anniversaryDate
      ? this.anniversaryDate.toISOString()
      : (undefined as any);
    data["commissionPercentage"] = this.commissionPercentage;
    data["flatCommissionFee"] = this.flatCommissionFee;
    data["brokerageSplit"] = this.brokerageSplit;
    data["splitCap"] = this.splitCap;
    data["additionalChargePercentage"] = this.additionalChargePercentage;
    data["additionalChargeCap"] = this.additionalChargeCap;
    data["flatTransactionalFees"] = this.flatTransactionalFees;
    data["referralOutFeeReceived"] = this.referralOutFeeReceived;
    data["referralFeePaid"] = this.referralFeePaid;
    data["rentalCommissionPercentage"] = this.rentalCommissionPercentage;
    return data;
  }
}

export interface ICreateBrokerageAnniversaryRequest {
  name?: string;
  anniversaryDate?: dayjs.Dayjs;
  commissionPercentage?: number;
  flatCommissionFee?: number;
  brokerageSplit?: number;
  splitCap?: number | undefined;
  additionalChargePercentage?: number;
  additionalChargeCap?: number | undefined;
  flatTransactionalFees?: number;
  referralOutFeeReceived?: number | undefined;
  referralFeePaid?: number | undefined;
  rentalCommissionPercentage?: number | undefined;
}

export class UserAreaResponse implements IUserAreaResponse {
  userAreaId?: number;
  areaType?: AreaTypeEnum;

  constructor(data?: IUserAreaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userAreaId = _data["userAreaId"];
      this.areaType = _data["areaType"];
    }
  }

  static fromJS(data: any): UserAreaResponse {
    data = typeof data === "object" ? data : {};
    let result = new UserAreaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userAreaId"] = this.userAreaId;
    data["areaType"] = this.areaType;
    return data;
  }
}

export interface IUserAreaResponse {
  userAreaId?: number;
  areaType?: AreaTypeEnum;
}

export class UpsertUserAreaRequest implements IUpsertUserAreaRequest {
  areaType!: AreaTypeEnum;

  constructor(data?: IUpsertUserAreaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.areaType = _data["areaType"];
    }
  }

  static fromJS(data: any): UpsertUserAreaRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpsertUserAreaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["areaType"] = this.areaType;
    return data;
  }
}

export interface IUpsertUserAreaRequest {
  areaType: AreaTypeEnum;
}

export class DuplicateCandidateResponse implements IDuplicateCandidateResponse {
  duplicateCandidateId?: number;
  sourceEntityType?: string;
  sourceEntityId?: number;
  sourceEntityName?: string;
  duplicateEntityId?: number;
  duplicateEntityName?: string;
  detectedDate?: dayjs.Dayjs;
  matchReason?: string;
  similarityScore?: number;

  constructor(data?: IDuplicateCandidateResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.duplicateCandidateId = _data["duplicateCandidateId"];
      this.sourceEntityType = _data["sourceEntityType"];
      this.sourceEntityId = _data["sourceEntityId"];
      this.sourceEntityName = _data["sourceEntityName"];
      this.duplicateEntityId = _data["duplicateEntityId"];
      this.duplicateEntityName = _data["duplicateEntityName"];
      this.detectedDate = _data["detectedDate"]
        ? dayjs(_data["detectedDate"].toString())
        : (undefined as any);
      this.matchReason = _data["matchReason"];
      this.similarityScore = _data["similarityScore"];
    }
  }

  static fromJS(data: any): DuplicateCandidateResponse {
    data = typeof data === "object" ? data : {};
    let result = new DuplicateCandidateResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["duplicateCandidateId"] = this.duplicateCandidateId;
    data["sourceEntityType"] = this.sourceEntityType;
    data["sourceEntityId"] = this.sourceEntityId;
    data["sourceEntityName"] = this.sourceEntityName;
    data["duplicateEntityId"] = this.duplicateEntityId;
    data["duplicateEntityName"] = this.duplicateEntityName;
    data["detectedDate"] = this.detectedDate
      ? this.detectedDate.toISOString()
      : (undefined as any);
    data["matchReason"] = this.matchReason;
    data["similarityScore"] = this.similarityScore;
    return data;
  }
}

export interface IDuplicateCandidateResponse {
  duplicateCandidateId?: number;
  sourceEntityType?: string;
  sourceEntityId?: number;
  sourceEntityName?: string;
  duplicateEntityId?: number;
  duplicateEntityName?: string;
  detectedDate?: dayjs.Dayjs;
  matchReason?: string;
  similarityScore?: number;
}

export class ResolveDuplicateCandidateRequest implements IResolveDuplicateCandidateRequest {
  duplicateCandidateId!: number;
  resolution!: DuplicateResolutionType;
  keepSourceEntity?: boolean;

  constructor(data?: IResolveDuplicateCandidateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.duplicateCandidateId = _data["duplicateCandidateId"];
      this.resolution = _data["resolution"];
      this.keepSourceEntity = _data["keepSourceEntity"];
    }
  }

  static fromJS(data: any): ResolveDuplicateCandidateRequest {
    data = typeof data === "object" ? data : {};
    let result = new ResolveDuplicateCandidateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["duplicateCandidateId"] = this.duplicateCandidateId;
    data["resolution"] = this.resolution;
    data["keepSourceEntity"] = this.keepSourceEntity;
    return data;
  }
}

export interface IResolveDuplicateCandidateRequest {
  duplicateCandidateId: number;
  resolution: DuplicateResolutionType;
  keepSourceEntity?: boolean;
}

export enum DuplicateResolutionType {
  Ignore = 0,
  Merge = 1,
}

export class ExtractSettlementDataHttpResponse implements IExtractSettlementDataHttpResponse {
  data?: SettlementData[];
  errors?: string[];

  constructor(data?: IExtractSettlementDataHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"])
          this.data!.push(SettlementData.fromJS(item));
      }
      if (Array.isArray(_data["errors"])) {
        this.errors = [] as any;
        for (let item of _data["errors"]) this.errors!.push(item);
      }
    }
  }

  static fromJS(data: any): ExtractSettlementDataHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ExtractSettlementDataHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data)
        data["data"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.errors)) {
      data["errors"] = [];
      for (let item of this.errors) data["errors"].push(item);
    }
    return data;
  }
}

export interface IExtractSettlementDataHttpResponse {
  data?: SettlementData[];
  errors?: string[];
}

export class SettlementData implements ISettlementData {
  id?: string;
  transactionTypeId?: number | undefined;
  propertyAddress?: string | undefined;
  settlementDate?: dayjs.Dayjs | undefined;
  buyers?: string[] | undefined;
  sellers?: string[] | undefined;
  price?: number | undefined;

  constructor(data?: ISettlementData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.transactionTypeId = _data["transactionTypeId"];
      this.propertyAddress = _data["propertyAddress"];
      this.settlementDate = _data["settlementDate"]
        ? dayjs(_data["settlementDate"].toString())
        : (undefined as any);
      if (Array.isArray(_data["buyers"])) {
        this.buyers = [] as any;
        for (let item of _data["buyers"]) this.buyers!.push(item);
      }
      if (Array.isArray(_data["sellers"])) {
        this.sellers = [] as any;
        for (let item of _data["sellers"]) this.sellers!.push(item);
      }
      this.price = _data["price"];
    }
  }

  static fromJS(data: any): SettlementData {
    data = typeof data === "object" ? data : {};
    let result = new SettlementData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["transactionTypeId"] = this.transactionTypeId;
    data["propertyAddress"] = this.propertyAddress;
    data["settlementDate"] = this.settlementDate
      ? this.settlementDate.toISOString()
      : (undefined as any);
    if (Array.isArray(this.buyers)) {
      data["buyers"] = [];
      for (let item of this.buyers) data["buyers"].push(item);
    }
    if (Array.isArray(this.sellers)) {
      data["sellers"] = [];
      for (let item of this.sellers) data["sellers"].push(item);
    }
    data["price"] = this.price;
    return data;
  }
}

export interface ISettlementData {
  id?: string;
  transactionTypeId?: number | undefined;
  propertyAddress?: string | undefined;
  settlementDate?: dayjs.Dayjs | undefined;
  buyers?: string[] | undefined;
  sellers?: string[] | undefined;
  price?: number | undefined;
}

export class EmailTemplate implements IEmailTemplate {
  id?: number;
  templateKey?: string;
  subject?: string;
  htmlBody?: string;
  description?: string | undefined;
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs;

  constructor(data?: IEmailTemplate) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.templateKey = _data["templateKey"];
      this.subject = _data["subject"];
      this.htmlBody = _data["htmlBody"];
      this.description = _data["description"];
      this.createdAt = _data["createdAt"]
        ? dayjs(_data["createdAt"].toString())
        : (undefined as any);
      this.updatedAt = _data["updatedAt"]
        ? dayjs(_data["updatedAt"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): EmailTemplate {
    data = typeof data === "object" ? data : {};
    let result = new EmailTemplate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["templateKey"] = this.templateKey;
    data["subject"] = this.subject;
    data["htmlBody"] = this.htmlBody;
    data["description"] = this.description;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : (undefined as any);
    data["updatedAt"] = this.updatedAt
      ? this.updatedAt.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IEmailTemplate {
  id?: number;
  templateKey?: string;
  subject?: string;
  htmlBody?: string;
  description?: string | undefined;
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs;
}

export class UpdateEmailTemplateRequest implements IUpdateEmailTemplateRequest {
  subject?: string;
  htmlBody?: string;

  constructor(data?: IUpdateEmailTemplateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subject = _data["subject"];
      this.htmlBody = _data["htmlBody"];
    }
  }

  static fromJS(data: any): UpdateEmailTemplateRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateEmailTemplateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["subject"] = this.subject;
    data["htmlBody"] = this.htmlBody;
    return data;
  }
}

export interface IUpdateEmailTemplateRequest {
  subject?: string;
  htmlBody?: string;
}

export class GciTrackerSettingsResponse implements IGciTrackerSettingsResponse {
  gciTrackerSettingsId?: number;
  userId?: string;
  targetAnnualIncome?: number;
  evaluationYears?: number[];
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs | undefined;

  constructor(data?: IGciTrackerSettingsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.gciTrackerSettingsId = _data["gciTrackerSettingsId"];
      this.userId = _data["userId"];
      this.targetAnnualIncome = _data["targetAnnualIncome"];
      if (Array.isArray(_data["evaluationYears"])) {
        this.evaluationYears = [] as any;
        for (let item of _data["evaluationYears"])
          this.evaluationYears!.push(item);
      }
      this.createdAt = _data["createdAt"]
        ? dayjs(_data["createdAt"].toString())
        : (undefined as any);
      this.updatedAt = _data["updatedAt"]
        ? dayjs(_data["updatedAt"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): GciTrackerSettingsResponse {
    data = typeof data === "object" ? data : {};
    let result = new GciTrackerSettingsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["gciTrackerSettingsId"] = this.gciTrackerSettingsId;
    data["userId"] = this.userId;
    data["targetAnnualIncome"] = this.targetAnnualIncome;
    if (Array.isArray(this.evaluationYears)) {
      data["evaluationYears"] = [];
      for (let item of this.evaluationYears) data["evaluationYears"].push(item);
    }
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : (undefined as any);
    data["updatedAt"] = this.updatedAt
      ? this.updatedAt.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IGciTrackerSettingsResponse {
  gciTrackerSettingsId?: number;
  userId?: string;
  targetAnnualIncome?: number;
  evaluationYears?: number[];
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs | undefined;
}

export class UpdateGciTrackerSettingsRequest implements IUpdateGciTrackerSettingsRequest {
  targetAnnualIncome?: number;
  evaluationYears?: number[];

  constructor(data?: IUpdateGciTrackerSettingsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.targetAnnualIncome = _data["targetAnnualIncome"];
      if (Array.isArray(_data["evaluationYears"])) {
        this.evaluationYears = [] as any;
        for (let item of _data["evaluationYears"])
          this.evaluationYears!.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateGciTrackerSettingsRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateGciTrackerSettingsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["targetAnnualIncome"] = this.targetAnnualIncome;
    if (Array.isArray(this.evaluationYears)) {
      data["evaluationYears"] = [];
      for (let item of this.evaluationYears) data["evaluationYears"].push(item);
    }
    return data;
  }
}

export interface IUpdateGciTrackerSettingsRequest {
  targetAnnualIncome?: number;
  evaluationYears?: number[];
}

export class PriceInfo implements IPriceInfo {
  priceId?: string;
  unitAmount?: number | undefined;
  currency?: string | undefined;
  recurring?: Recurring | undefined;
  product?: ProductDto;
  name?: string;
  description?: string;
  features?: string[];
  type?: string;
  unitLabel?: string;
  url?: string;

  constructor(data?: IPriceInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.priceId = _data["priceId"];
      this.unitAmount = _data["unitAmount"];
      this.currency = _data["currency"];
      this.recurring = _data["recurring"]
        ? Recurring.fromJS(_data["recurring"])
        : (undefined as any);
      this.product = _data["product"]
        ? ProductDto.fromJS(_data["product"])
        : (undefined as any);
      this.name = _data["name"];
      this.description = _data["description"];
      if (Array.isArray(_data["features"])) {
        this.features = [] as any;
        for (let item of _data["features"]) this.features!.push(item);
      }
      this.type = _data["type"];
      this.unitLabel = _data["unitLabel"];
      this.url = _data["url"];
    }
  }

  static fromJS(data: any): PriceInfo {
    data = typeof data === "object" ? data : {};
    let result = new PriceInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["priceId"] = this.priceId;
    data["unitAmount"] = this.unitAmount;
    data["currency"] = this.currency;
    data["recurring"] = this.recurring
      ? this.recurring.toJSON()
      : (undefined as any);
    data["product"] = this.product ? this.product.toJSON() : (undefined as any);
    data["name"] = this.name;
    data["description"] = this.description;
    if (Array.isArray(this.features)) {
      data["features"] = [];
      for (let item of this.features) data["features"].push(item);
    }
    data["type"] = this.type;
    data["unitLabel"] = this.unitLabel;
    data["url"] = this.url;
    return data;
  }
}

export interface IPriceInfo {
  priceId?: string;
  unitAmount?: number | undefined;
  currency?: string | undefined;
  recurring?: Recurring | undefined;
  product?: ProductDto;
  name?: string;
  description?: string;
  features?: string[];
  type?: string;
  unitLabel?: string;
  url?: string;
}

export class Recurring implements IRecurring {
  interval?: string | undefined;
  intervalCount?: number | undefined;

  constructor(data?: IRecurring) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.interval = _data["interval"];
      this.intervalCount = _data["intervalCount"];
    }
  }

  static fromJS(data: any): Recurring {
    data = typeof data === "object" ? data : {};
    let result = new Recurring();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["interval"] = this.interval;
    data["intervalCount"] = this.intervalCount;
    return data;
  }
}

export interface IRecurring {
  interval?: string | undefined;
  intervalCount?: number | undefined;
}

export class ProductDto implements IProductDto {
  id?: string;
  name?: string;
  description?: string;
  features?: string[];
  priceId?: string;
  unitAmount?: number | undefined;
  currency?: string;
  interval?: string;
  intervalCount?: number | undefined;
  annualSavings?: number | undefined;

  constructor(data?: IProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      if (Array.isArray(_data["features"])) {
        this.features = [] as any;
        for (let item of _data["features"]) this.features!.push(item);
      }
      this.priceId = _data["priceId"];
      this.unitAmount = _data["unitAmount"];
      this.currency = _data["currency"];
      this.interval = _data["interval"];
      this.intervalCount = _data["intervalCount"];
      this.annualSavings = _data["annualSavings"];
    }
  }

  static fromJS(data: any): ProductDto {
    data = typeof data === "object" ? data : {};
    let result = new ProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    if (Array.isArray(this.features)) {
      data["features"] = [];
      for (let item of this.features) data["features"].push(item);
    }
    data["priceId"] = this.priceId;
    data["unitAmount"] = this.unitAmount;
    data["currency"] = this.currency;
    data["interval"] = this.interval;
    data["intervalCount"] = this.intervalCount;
    data["annualSavings"] = this.annualSavings;
    return data;
  }
}

export interface IProductDto {
  id?: string;
  name?: string;
  description?: string;
  features?: string[];
  priceId?: string;
  unitAmount?: number | undefined;
  currency?: string;
  interval?: string;
  intervalCount?: number | undefined;
  annualSavings?: number | undefined;
}

export class PropMixStatsResponse implements IPropMixStatsResponse {
  todaysCallCount?: number;
  todaysFailedCount?: number;
  todaysNoDataCount?: number;
  monthlyCallCount?: number;
  monthlyFailedCount?: number;
  monthlyNoDataCount?: number;
  dailyLimit?: number;
  monthlyLimit?: number;
  dailyRemaining?: number;
  monthlyRemaining?: number;
  pendingFailures?: PropMixFailureDto[];

  constructor(data?: IPropMixStatsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.todaysCallCount = _data["todaysCallCount"];
      this.todaysFailedCount = _data["todaysFailedCount"];
      this.todaysNoDataCount = _data["todaysNoDataCount"];
      this.monthlyCallCount = _data["monthlyCallCount"];
      this.monthlyFailedCount = _data["monthlyFailedCount"];
      this.monthlyNoDataCount = _data["monthlyNoDataCount"];
      this.dailyLimit = _data["dailyLimit"];
      this.monthlyLimit = _data["monthlyLimit"];
      this.dailyRemaining = _data["dailyRemaining"];
      this.monthlyRemaining = _data["monthlyRemaining"];
      if (Array.isArray(_data["pendingFailures"])) {
        this.pendingFailures = [] as any;
        for (let item of _data["pendingFailures"])
          this.pendingFailures!.push(PropMixFailureDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PropMixStatsResponse {
    data = typeof data === "object" ? data : {};
    let result = new PropMixStatsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["todaysCallCount"] = this.todaysCallCount;
    data["todaysFailedCount"] = this.todaysFailedCount;
    data["todaysNoDataCount"] = this.todaysNoDataCount;
    data["monthlyCallCount"] = this.monthlyCallCount;
    data["monthlyFailedCount"] = this.monthlyFailedCount;
    data["monthlyNoDataCount"] = this.monthlyNoDataCount;
    data["dailyLimit"] = this.dailyLimit;
    data["monthlyLimit"] = this.monthlyLimit;
    data["dailyRemaining"] = this.dailyRemaining;
    data["monthlyRemaining"] = this.monthlyRemaining;
    if (Array.isArray(this.pendingFailures)) {
      data["pendingFailures"] = [];
      for (let item of this.pendingFailures)
        data["pendingFailures"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IPropMixStatsResponse {
  todaysCallCount?: number;
  todaysFailedCount?: number;
  todaysNoDataCount?: number;
  monthlyCallCount?: number;
  monthlyFailedCount?: number;
  monthlyNoDataCount?: number;
  dailyLimit?: number;
  monthlyLimit?: number;
  dailyRemaining?: number;
  monthlyRemaining?: number;
  pendingFailures?: PropMixFailureDto[];
}

export class PropMixFailureDto implements IPropMixFailureDto {
  failureId?: number;
  userId?: string;
  transactionId?: number | undefined;
  transactionDate?: dayjs.Dayjs | undefined;
  transactionType?: string | undefined;
  price?: number | undefined;
  streetAddress?: string;
  city?: string | undefined;
  state?: string | undefined;
  postalCode?: string | undefined;
  errorMessage?: string | undefined;
  failureType?: string;
  retryCount?: number;
  status?: string;
  createdAt?: dayjs.Dayjs;

  constructor(data?: IPropMixFailureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.failureId = _data["failureId"];
      this.userId = _data["userId"];
      this.transactionId = _data["transactionId"];
      this.transactionDate = _data["transactionDate"]
        ? dayjs(_data["transactionDate"].toString())
        : (undefined as any);
      this.transactionType = _data["transactionType"];
      this.price = _data["price"];
      this.streetAddress = _data["streetAddress"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.postalCode = _data["postalCode"];
      this.errorMessage = _data["errorMessage"];
      this.failureType = _data["failureType"];
      this.retryCount = _data["retryCount"];
      this.status = _data["status"];
      this.createdAt = _data["createdAt"]
        ? dayjs(_data["createdAt"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): PropMixFailureDto {
    data = typeof data === "object" ? data : {};
    let result = new PropMixFailureDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["failureId"] = this.failureId;
    data["userId"] = this.userId;
    data["transactionId"] = this.transactionId;
    data["transactionDate"] = this.transactionDate
      ? this.transactionDate.toISOString()
      : (undefined as any);
    data["transactionType"] = this.transactionType;
    data["price"] = this.price;
    data["streetAddress"] = this.streetAddress;
    data["city"] = this.city;
    data["state"] = this.state;
    data["postalCode"] = this.postalCode;
    data["errorMessage"] = this.errorMessage;
    data["failureType"] = this.failureType;
    data["retryCount"] = this.retryCount;
    data["status"] = this.status;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IPropMixFailureDto {
  failureId?: number;
  userId?: string;
  transactionId?: number | undefined;
  transactionDate?: dayjs.Dayjs | undefined;
  transactionType?: string | undefined;
  price?: number | undefined;
  streetAddress?: string;
  city?: string | undefined;
  state?: string | undefined;
  postalCode?: string | undefined;
  errorMessage?: string | undefined;
  failureType?: string;
  retryCount?: number;
  status?: string;
  createdAt?: dayjs.Dayjs;
}

export class PropMixUserSummaryDto implements IPropMixUserSummaryDto {
  userId?: string;
  userName?: string;
  pendingCount?: number;
  noDataCount?: number;
  errorCount?: number;

  constructor(data?: IPropMixUserSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.userName = _data["userName"];
      this.pendingCount = _data["pendingCount"];
      this.noDataCount = _data["noDataCount"];
      this.errorCount = _data["errorCount"];
    }
  }

  static fromJS(data: any): PropMixUserSummaryDto {
    data = typeof data === "object" ? data : {};
    let result = new PropMixUserSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.userId;
    data["userName"] = this.userName;
    data["pendingCount"] = this.pendingCount;
    data["noDataCount"] = this.noDataCount;
    data["errorCount"] = this.errorCount;
    return data;
  }
}

export interface IPropMixUserSummaryDto {
  userId?: string;
  userName?: string;
  pendingCount?: number;
  noDataCount?: number;
  errorCount?: number;
}

export class PropMixRetryResultDto implements IPropMixRetryResultDto {
  failureId?: number;
  success?: boolean;
  noDataFound?: boolean;
  errorMessage?: string | undefined;
  buyerNames?: string[];
  sellerNames?: string[];

  constructor(data?: IPropMixRetryResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.failureId = _data["failureId"];
      this.success = _data["success"];
      this.noDataFound = _data["noDataFound"];
      this.errorMessage = _data["errorMessage"];
      if (Array.isArray(_data["buyerNames"])) {
        this.buyerNames = [] as any;
        for (let item of _data["buyerNames"]) this.buyerNames!.push(item);
      }
      if (Array.isArray(_data["sellerNames"])) {
        this.sellerNames = [] as any;
        for (let item of _data["sellerNames"]) this.sellerNames!.push(item);
      }
    }
  }

  static fromJS(data: any): PropMixRetryResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PropMixRetryResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["failureId"] = this.failureId;
    data["success"] = this.success;
    data["noDataFound"] = this.noDataFound;
    data["errorMessage"] = this.errorMessage;
    if (Array.isArray(this.buyerNames)) {
      data["buyerNames"] = [];
      for (let item of this.buyerNames) data["buyerNames"].push(item);
    }
    if (Array.isArray(this.sellerNames)) {
      data["sellerNames"] = [];
      for (let item of this.sellerNames) data["sellerNames"].push(item);
    }
    return data;
  }
}

export interface IPropMixRetryResultDto {
  failureId?: number;
  success?: boolean;
  noDataFound?: boolean;
  errorMessage?: string | undefined;
  buyerNames?: string[];
  sellerNames?: string[];
}

export class PropMixBulkRetryResultDto implements IPropMixBulkRetryResultDto {
  totalAttempted?: number;
  successCount?: number;
  failedCount?: number;
  noDataCount?: number;
  results?: PropMixRetryResultDto[];

  constructor(data?: IPropMixBulkRetryResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalAttempted = _data["totalAttempted"];
      this.successCount = _data["successCount"];
      this.failedCount = _data["failedCount"];
      this.noDataCount = _data["noDataCount"];
      if (Array.isArray(_data["results"])) {
        this.results = [] as any;
        for (let item of _data["results"])
          this.results!.push(PropMixRetryResultDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PropMixBulkRetryResultDto {
    data = typeof data === "object" ? data : {};
    let result = new PropMixBulkRetryResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalAttempted"] = this.totalAttempted;
    data["successCount"] = this.successCount;
    data["failedCount"] = this.failedCount;
    data["noDataCount"] = this.noDataCount;
    if (Array.isArray(this.results)) {
      data["results"] = [];
      for (let item of this.results)
        data["results"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IPropMixBulkRetryResultDto {
  totalAttempted?: number;
  successCount?: number;
  failedCount?: number;
  noDataCount?: number;
  results?: PropMixRetryResultDto[];
}

export class ActiveSubscriptionHttpResponse implements IActiveSubscriptionHttpResponse {
  activeSubscription?: Subscription | undefined;

  constructor(data?: IActiveSubscriptionHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activeSubscription = _data["activeSubscription"]
        ? Subscription.fromJS(_data["activeSubscription"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): ActiveSubscriptionHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ActiveSubscriptionHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["activeSubscription"] = this.activeSubscription
      ? this.activeSubscription.toJSON()
      : (undefined as any);
    return data;
  }
}

export interface IActiveSubscriptionHttpResponse {
  activeSubscription?: Subscription | undefined;
}

export class Subscription implements ISubscription {
  plan?: string;
  unitAmount?: number | undefined;
  created?: dayjs.Dayjs;
  currency?: string;
  daysUntilDue?: number | undefined;
  currentPeriodStart?: dayjs.Dayjs;
  currentPeriodEnd?: dayjs.Dayjs;
  startDate?: dayjs.Dayjs;
  status?: string;
  trialStart?: dayjs.Dayjs | undefined;
  trialEnd?: dayjs.Dayjs | undefined;
  description?: string;
  interval?: string | undefined;

  constructor(data?: ISubscription) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.plan = _data["plan"];
      this.unitAmount = _data["unitAmount"];
      this.created = _data["created"]
        ? dayjs(_data["created"].toString())
        : (undefined as any);
      this.currency = _data["currency"];
      this.daysUntilDue = _data["daysUntilDue"];
      this.currentPeriodStart = _data["currentPeriodStart"]
        ? dayjs(_data["currentPeriodStart"].toString())
        : (undefined as any);
      this.currentPeriodEnd = _data["currentPeriodEnd"]
        ? dayjs(_data["currentPeriodEnd"].toString())
        : (undefined as any);
      this.startDate = _data["startDate"]
        ? dayjs(_data["startDate"].toString())
        : (undefined as any);
      this.status = _data["status"];
      this.trialStart = _data["trialStart"]
        ? dayjs(_data["trialStart"].toString())
        : (undefined as any);
      this.trialEnd = _data["trialEnd"]
        ? dayjs(_data["trialEnd"].toString())
        : (undefined as any);
      this.description = _data["description"];
      this.interval = _data["interval"];
    }
  }

  static fromJS(data: any): Subscription {
    data = typeof data === "object" ? data : {};
    let result = new Subscription();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["plan"] = this.plan;
    data["unitAmount"] = this.unitAmount;
    data["created"] = this.created
      ? this.created.toISOString()
      : (undefined as any);
    data["currency"] = this.currency;
    data["daysUntilDue"] = this.daysUntilDue;
    data["currentPeriodStart"] = this.currentPeriodStart
      ? this.currentPeriodStart.toISOString()
      : (undefined as any);
    data["currentPeriodEnd"] = this.currentPeriodEnd
      ? this.currentPeriodEnd.toISOString()
      : (undefined as any);
    data["startDate"] = this.startDate
      ? this.startDate.toISOString()
      : (undefined as any);
    data["status"] = this.status;
    data["trialStart"] = this.trialStart
      ? this.trialStart.toISOString()
      : (undefined as any);
    data["trialEnd"] = this.trialEnd
      ? this.trialEnd.toISOString()
      : (undefined as any);
    data["description"] = this.description;
    data["interval"] = this.interval;
    return data;
  }
}

export interface ISubscription {
  plan?: string;
  unitAmount?: number | undefined;
  created?: dayjs.Dayjs;
  currency?: string;
  daysUntilDue?: number | undefined;
  currentPeriodStart?: dayjs.Dayjs;
  currentPeriodEnd?: dayjs.Dayjs;
  startDate?: dayjs.Dayjs;
  status?: string;
  trialStart?: dayjs.Dayjs | undefined;
  trialEnd?: dayjs.Dayjs | undefined;
  description?: string;
  interval?: string | undefined;
}

export class TransactionSummary implements ITransactionSummary {
  totalVolume?: number;
  totalUnits?: number;
  averagePrice?: number;
  type?: string;
  isSb?: boolean;
  status?: TransactionStatus;

  constructor(data?: ITransactionSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.totalVolume = _data["totalVolume"];
      this.totalUnits = _data["totalUnits"];
      this.averagePrice = _data["averagePrice"];
      this.type = _data["type"];
      this.isSb = _data["isSb"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): TransactionSummary {
    data = typeof data === "object" ? data : {};
    let result = new TransactionSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["totalVolume"] = this.totalVolume;
    data["totalUnits"] = this.totalUnits;
    data["averagePrice"] = this.averagePrice;
    data["type"] = this.type;
    data["isSb"] = this.isSb;
    data["status"] = this.status;
    return data;
  }
}

export interface ITransactionSummary {
  totalVolume?: number;
  totalUnits?: number;
  averagePrice?: number;
  type?: string;
  isSb?: boolean;
  status?: TransactionStatus;
}

export class TransactionYear implements ITransactionYear {
  year?: number;
  transactionCount?: number;
  id?: number;

  constructor(data?: ITransactionYear) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.year = _data["year"];
      this.transactionCount = _data["transactionCount"];
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): TransactionYear {
    data = typeof data === "object" ? data : {};
    let result = new TransactionYear();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["year"] = this.year;
    data["transactionCount"] = this.transactionCount;
    data["id"] = this.id;
    return data;
  }
}

export interface ITransactionYear {
  year?: number;
  transactionCount?: number;
  id?: number;
}

export class PipelineFolderInfo implements IPipelineFolderInfo {
  id?: number;
  entryCount?: number;
  overdueCount?: number;

  constructor(data?: IPipelineFolderInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.entryCount = _data["entryCount"];
      this.overdueCount = _data["overdueCount"];
    }
  }

  static fromJS(data: any): PipelineFolderInfo {
    data = typeof data === "object" ? data : {};
    let result = new PipelineFolderInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["entryCount"] = this.entryCount;
    data["overdueCount"] = this.overdueCount;
    return data;
  }
}

export interface IPipelineFolderInfo {
  id?: number;
  entryCount?: number;
  overdueCount?: number;
}

export class ToolState implements IToolState {
  name?: string;
  enabled?: boolean;

  constructor(data?: IToolState) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.enabled = _data["enabled"];
    }
  }

  static fromJS(data: any): ToolState {
    data = typeof data === "object" ? data : {};
    let result = new ToolState();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["enabled"] = this.enabled;
    return data;
  }
}

export interface IToolState {
  name?: string;
  enabled?: boolean;
}

export class SetToolResponse implements ISetToolResponse {
  enabled?: boolean;

  constructor(data?: ISetToolResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.enabled = _data["enabled"];
    }
  }

  static fromJS(data: any): SetToolResponse {
    data = typeof data === "object" ? data : {};
    let result = new SetToolResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["enabled"] = this.enabled;
    return data;
  }
}

export interface ISetToolResponse {
  enabled?: boolean;
}

export enum TransactionStatus {
  Lead = 1,
  Active = 2,
  Transaction = 3,
  UnderContract = 4,
}

export class UpsertTransactionResult implements IUpsertTransactionResult {
  id?: number | undefined;
  isDuplicate?: boolean;
  duplicateId?: number | undefined;
  createdEntities?: CreatedEntityInfo | undefined;

  constructor(data?: IUpsertTransactionResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.isDuplicate = _data["isDuplicate"];
      this.duplicateId = _data["duplicateId"];
      this.createdEntities = _data["createdEntities"]
        ? CreatedEntityInfo.fromJS(_data["createdEntities"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): UpsertTransactionResult {
    data = typeof data === "object" ? data : {};
    let result = new UpsertTransactionResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["isDuplicate"] = this.isDuplicate;
    data["duplicateId"] = this.duplicateId;
    data["createdEntities"] = this.createdEntities
      ? this.createdEntities.toJSON()
      : (undefined as any);
    return data;
  }
}

export interface IUpsertTransactionResult {
  id?: number | undefined;
  isDuplicate?: boolean;
  duplicateId?: number | undefined;
  createdEntities?: CreatedEntityInfo | undefined;
}

export class CreatedEntityInfo implements ICreatedEntityInfo {
  specialTags?: LookupItemSimple[] | undefined;
  specialGroups?: LookupItemSimple[] | undefined;
  coAgents?: LookupItemSimple[] | undefined;
  area?: LookupItemSimple | undefined;
  reasons?: LookupItemSimple[] | undefined;
  sources?: LookupItemSimple[] | undefined;

  constructor(data?: ICreatedEntityInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["specialTags"])) {
        this.specialTags = [] as any;
        for (let item of _data["specialTags"])
          this.specialTags!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["specialGroups"])) {
        this.specialGroups = [] as any;
        for (let item of _data["specialGroups"])
          this.specialGroups!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["coAgents"])) {
        this.coAgents = [] as any;
        for (let item of _data["coAgents"])
          this.coAgents!.push(LookupItemSimple.fromJS(item));
      }
      this.area = _data["area"]
        ? LookupItemSimple.fromJS(_data["area"])
        : (undefined as any);
      if (Array.isArray(_data["reasons"])) {
        this.reasons = [] as any;
        for (let item of _data["reasons"])
          this.reasons!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["sources"])) {
        this.sources = [] as any;
        for (let item of _data["sources"])
          this.sources!.push(LookupItemSimple.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CreatedEntityInfo {
    data = typeof data === "object" ? data : {};
    let result = new CreatedEntityInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.specialTags)) {
      data["specialTags"] = [];
      for (let item of this.specialTags)
        data["specialTags"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.specialGroups)) {
      data["specialGroups"] = [];
      for (let item of this.specialGroups)
        data["specialGroups"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.coAgents)) {
      data["coAgents"] = [];
      for (let item of this.coAgents)
        data["coAgents"].push(item ? item.toJSON() : (undefined as any));
    }
    data["area"] = this.area ? this.area.toJSON() : (undefined as any);
    if (Array.isArray(this.reasons)) {
      data["reasons"] = [];
      for (let item of this.reasons)
        data["reasons"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.sources)) {
      data["sources"] = [];
      for (let item of this.sources)
        data["sources"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ICreatedEntityInfo {
  specialTags?: LookupItemSimple[] | undefined;
  specialGroups?: LookupItemSimple[] | undefined;
  coAgents?: LookupItemSimple[] | undefined;
  area?: LookupItemSimple | undefined;
  reasons?: LookupItemSimple[] | undefined;
  sources?: LookupItemSimple[] | undefined;
}

export class UpsertTransactionHttpRequest implements IUpsertTransactionHttpRequest {
  transaction?: UpsertTransactionDto;

  constructor(data?: IUpsertTransactionHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transaction = _data["transaction"]
        ? UpsertTransactionDto.fromJS(_data["transaction"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): UpsertTransactionHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpsertTransactionHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["transaction"] = this.transaction
      ? this.transaction.toJSON()
      : (undefined as any);
    return data;
  }
}

export interface IUpsertTransactionHttpRequest {
  transaction?: UpsertTransactionDto;
}

export class UpsertTransactionDto implements IUpsertTransactionDto {
  transactionId?: number | undefined;
  typeId?: number;
  date?: dayjs.Dayjs;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  price?: number;
  notes?: string | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  coAgent2Id?: number | undefined;
  insertedArea?: string | undefined;
  insertedCoAgent?: string | undefined;
  insertedCoAgent2?: string | undefined;
  insertedSource?: string | undefined;
  insertedReason?: string | undefined;
  selectedClients?: number[] | undefined;
  insertedClients?: string[] | undefined;
  selectedGroups?: number[] | undefined;
  insertedGroups?: string[] | undefined;
  selectedTags?: number[] | undefined;
  insertedTags?: string[] | undefined;
  selectedSoiReferrers?: number[] | undefined;
  insertedSoiReferrers?: string[] | undefined;
  selectedAgentReferrers?: number[] | undefined;
  insertedAgentReferrers?: string[] | undefined;
  selectedVendorReferrers?: number[] | undefined;
  insertedVendorReferrers?: string[] | undefined;
  selectedVendors?: number[] | undefined;
  insertedVendors?: string[] | undefined;
  selectedAgentReferredOut?: number[] | undefined;
  insertedAgentReferredOut?: string[] | undefined;
  referralOutTypeId?: number | undefined;
  numClients?: number;
  forceDuplicate?: boolean | undefined;
  replace?: boolean;
  status?: TransactionStatus;
  leadReceivedDate?: dayjs.Dayjs | undefined;
  address?: Address;

  constructor(data?: IUpsertTransactionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionId = _data["transactionId"];
      this.typeId = _data["typeId"];
      this.date = _data["date"]
        ? dayjs(_data["date"].toString())
        : (undefined as any);
      this.sourceId = _data["sourceId"];
      this.reasonId = _data["reasonId"];
      this.price = _data["price"];
      this.notes = _data["notes"];
      this.areaId = _data["areaId"];
      this.coAgentId = _data["coAgentId"];
      this.coAgent2Id = _data["coAgent2Id"];
      this.insertedArea = _data["insertedArea"];
      this.insertedCoAgent = _data["insertedCoAgent"];
      this.insertedCoAgent2 = _data["insertedCoAgent2"];
      this.insertedSource = _data["insertedSource"];
      this.insertedReason = _data["insertedReason"];
      if (Array.isArray(_data["selectedClients"])) {
        this.selectedClients = [] as any;
        for (let item of _data["selectedClients"])
          this.selectedClients!.push(item);
      }
      if (Array.isArray(_data["insertedClients"])) {
        this.insertedClients = [] as any;
        for (let item of _data["insertedClients"])
          this.insertedClients!.push(item);
      }
      if (Array.isArray(_data["selectedGroups"])) {
        this.selectedGroups = [] as any;
        for (let item of _data["selectedGroups"])
          this.selectedGroups!.push(item);
      }
      if (Array.isArray(_data["insertedGroups"])) {
        this.insertedGroups = [] as any;
        for (let item of _data["insertedGroups"])
          this.insertedGroups!.push(item);
      }
      if (Array.isArray(_data["selectedTags"])) {
        this.selectedTags = [] as any;
        for (let item of _data["selectedTags"]) this.selectedTags!.push(item);
      }
      if (Array.isArray(_data["insertedTags"])) {
        this.insertedTags = [] as any;
        for (let item of _data["insertedTags"]) this.insertedTags!.push(item);
      }
      if (Array.isArray(_data["selectedSoiReferrers"])) {
        this.selectedSoiReferrers = [] as any;
        for (let item of _data["selectedSoiReferrers"])
          this.selectedSoiReferrers!.push(item);
      }
      if (Array.isArray(_data["insertedSoiReferrers"])) {
        this.insertedSoiReferrers = [] as any;
        for (let item of _data["insertedSoiReferrers"])
          this.insertedSoiReferrers!.push(item);
      }
      if (Array.isArray(_data["selectedAgentReferrers"])) {
        this.selectedAgentReferrers = [] as any;
        for (let item of _data["selectedAgentReferrers"])
          this.selectedAgentReferrers!.push(item);
      }
      if (Array.isArray(_data["insertedAgentReferrers"])) {
        this.insertedAgentReferrers = [] as any;
        for (let item of _data["insertedAgentReferrers"])
          this.insertedAgentReferrers!.push(item);
      }
      if (Array.isArray(_data["selectedVendorReferrers"])) {
        this.selectedVendorReferrers = [] as any;
        for (let item of _data["selectedVendorReferrers"])
          this.selectedVendorReferrers!.push(item);
      }
      if (Array.isArray(_data["insertedVendorReferrers"])) {
        this.insertedVendorReferrers = [] as any;
        for (let item of _data["insertedVendorReferrers"])
          this.insertedVendorReferrers!.push(item);
      }
      if (Array.isArray(_data["selectedVendors"])) {
        this.selectedVendors = [] as any;
        for (let item of _data["selectedVendors"])
          this.selectedVendors!.push(item);
      }
      if (Array.isArray(_data["insertedVendors"])) {
        this.insertedVendors = [] as any;
        for (let item of _data["insertedVendors"])
          this.insertedVendors!.push(item);
      }
      if (Array.isArray(_data["selectedAgentReferredOut"])) {
        this.selectedAgentReferredOut = [] as any;
        for (let item of _data["selectedAgentReferredOut"])
          this.selectedAgentReferredOut!.push(item);
      }
      if (Array.isArray(_data["insertedAgentReferredOut"])) {
        this.insertedAgentReferredOut = [] as any;
        for (let item of _data["insertedAgentReferredOut"])
          this.insertedAgentReferredOut!.push(item);
      }
      this.referralOutTypeId = _data["referralOutTypeId"];
      this.numClients = _data["numClients"];
      this.forceDuplicate = _data["forceDuplicate"];
      this.replace = _data["replace"];
      this.status = _data["status"];
      this.leadReceivedDate = _data["leadReceivedDate"]
        ? dayjs(_data["leadReceivedDate"].toString())
        : (undefined as any);
      this.address = _data["address"]
        ? Address.fromJS(_data["address"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): UpsertTransactionDto {
    data = typeof data === "object" ? data : {};
    let result = new UpsertTransactionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["transactionId"] = this.transactionId;
    data["typeId"] = this.typeId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["sourceId"] = this.sourceId;
    data["reasonId"] = this.reasonId;
    data["price"] = this.price;
    data["notes"] = this.notes;
    data["areaId"] = this.areaId;
    data["coAgentId"] = this.coAgentId;
    data["coAgent2Id"] = this.coAgent2Id;
    data["insertedArea"] = this.insertedArea;
    data["insertedCoAgent"] = this.insertedCoAgent;
    data["insertedCoAgent2"] = this.insertedCoAgent2;
    data["insertedSource"] = this.insertedSource;
    data["insertedReason"] = this.insertedReason;
    if (Array.isArray(this.selectedClients)) {
      data["selectedClients"] = [];
      for (let item of this.selectedClients) data["selectedClients"].push(item);
    }
    if (Array.isArray(this.insertedClients)) {
      data["insertedClients"] = [];
      for (let item of this.insertedClients) data["insertedClients"].push(item);
    }
    if (Array.isArray(this.selectedGroups)) {
      data["selectedGroups"] = [];
      for (let item of this.selectedGroups) data["selectedGroups"].push(item);
    }
    if (Array.isArray(this.insertedGroups)) {
      data["insertedGroups"] = [];
      for (let item of this.insertedGroups) data["insertedGroups"].push(item);
    }
    if (Array.isArray(this.selectedTags)) {
      data["selectedTags"] = [];
      for (let item of this.selectedTags) data["selectedTags"].push(item);
    }
    if (Array.isArray(this.insertedTags)) {
      data["insertedTags"] = [];
      for (let item of this.insertedTags) data["insertedTags"].push(item);
    }
    if (Array.isArray(this.selectedSoiReferrers)) {
      data["selectedSoiReferrers"] = [];
      for (let item of this.selectedSoiReferrers)
        data["selectedSoiReferrers"].push(item);
    }
    if (Array.isArray(this.insertedSoiReferrers)) {
      data["insertedSoiReferrers"] = [];
      for (let item of this.insertedSoiReferrers)
        data["insertedSoiReferrers"].push(item);
    }
    if (Array.isArray(this.selectedAgentReferrers)) {
      data["selectedAgentReferrers"] = [];
      for (let item of this.selectedAgentReferrers)
        data["selectedAgentReferrers"].push(item);
    }
    if (Array.isArray(this.insertedAgentReferrers)) {
      data["insertedAgentReferrers"] = [];
      for (let item of this.insertedAgentReferrers)
        data["insertedAgentReferrers"].push(item);
    }
    if (Array.isArray(this.selectedVendorReferrers)) {
      data["selectedVendorReferrers"] = [];
      for (let item of this.selectedVendorReferrers)
        data["selectedVendorReferrers"].push(item);
    }
    if (Array.isArray(this.insertedVendorReferrers)) {
      data["insertedVendorReferrers"] = [];
      for (let item of this.insertedVendorReferrers)
        data["insertedVendorReferrers"].push(item);
    }
    if (Array.isArray(this.selectedVendors)) {
      data["selectedVendors"] = [];
      for (let item of this.selectedVendors) data["selectedVendors"].push(item);
    }
    if (Array.isArray(this.insertedVendors)) {
      data["insertedVendors"] = [];
      for (let item of this.insertedVendors) data["insertedVendors"].push(item);
    }
    if (Array.isArray(this.selectedAgentReferredOut)) {
      data["selectedAgentReferredOut"] = [];
      for (let item of this.selectedAgentReferredOut)
        data["selectedAgentReferredOut"].push(item);
    }
    if (Array.isArray(this.insertedAgentReferredOut)) {
      data["insertedAgentReferredOut"] = [];
      for (let item of this.insertedAgentReferredOut)
        data["insertedAgentReferredOut"].push(item);
    }
    data["referralOutTypeId"] = this.referralOutTypeId;
    data["numClients"] = this.numClients;
    data["forceDuplicate"] = this.forceDuplicate;
    data["replace"] = this.replace;
    data["status"] = this.status;
    data["leadReceivedDate"] = this.leadReceivedDate ? this.leadReceivedDate.toISOString() : (undefined as any);
    data["address"] = this.address ? this.address.toJSON() : (undefined as any);
    return data;
  }
}

export interface IUpsertTransactionDto {
  transactionId?: number | undefined;
  typeId?: number;
  date?: dayjs.Dayjs;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  price?: number;
  notes?: string | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  coAgent2Id?: number | undefined;
  insertedArea?: string | undefined;
  insertedCoAgent?: string | undefined;
  insertedCoAgent2?: string | undefined;
  insertedSource?: string | undefined;
  insertedReason?: string | undefined;
  selectedClients?: number[] | undefined;
  insertedClients?: string[] | undefined;
  selectedGroups?: number[] | undefined;
  insertedGroups?: string[] | undefined;
  selectedTags?: number[] | undefined;
  insertedTags?: string[] | undefined;
  selectedSoiReferrers?: number[] | undefined;
  insertedSoiReferrers?: string[] | undefined;
  selectedAgentReferrers?: number[] | undefined;
  insertedAgentReferrers?: string[] | undefined;
  selectedVendorReferrers?: number[] | undefined;
  insertedVendorReferrers?: string[] | undefined;
  selectedVendors?: number[] | undefined;
  insertedVendors?: string[] | undefined;
  selectedAgentReferredOut?: number[] | undefined;
  insertedAgentReferredOut?: string[] | undefined;
  referralOutTypeId?: number | undefined;
  numClients?: number;
  forceDuplicate?: boolean | undefined;
  replace?: boolean;
  status?: TransactionStatus;
  leadReceivedDate?: dayjs.Dayjs | undefined;
  address?: Address;
}

export class Address implements IAddress {
  formattedAddress?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  street?: string | undefined;
  subpremise?: string | undefined;
  zip?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  country?: string | undefined;
  county?: string | undefined;
  manualStreetAddress?: string | undefined;

  constructor(data?: IAddress) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.formattedAddress = _data["formattedAddress"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.street = _data["street"];
      this.subpremise = _data["subpremise"];
      this.zip = _data["zip"];
      this.latitude = _data["latitude"];
      this.longitude = _data["longitude"];
      this.country = _data["country"];
      this.county = _data["county"];
      this.manualStreetAddress = _data["manualStreetAddress"];
    }
  }

  static fromJS(data: any): Address {
    data = typeof data === "object" ? data : {};
    let result = new Address();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["formattedAddress"] = this.formattedAddress;
    data["city"] = this.city;
    data["state"] = this.state;
    data["street"] = this.street;
    data["subpremise"] = this.subpremise;
    data["zip"] = this.zip;
    data["latitude"] = this.latitude;
    data["longitude"] = this.longitude;
    data["country"] = this.country;
    data["county"] = this.county;
    data["manualStreetAddress"] = this.manualStreetAddress;
    return data;
  }
}

export interface IAddress {
  formattedAddress?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  street?: string | undefined;
  subpremise?: string | undefined;
  zip?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  country?: string | undefined;
  county?: string | undefined;
  manualStreetAddress?: string | undefined;
}

export class UpsertFinancialsHttpRequest implements IUpsertFinancialsHttpRequest {
  financial?: FinancialDto;
  transactionId?: number;

  constructor(data?: IUpsertFinancialsHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.financial = _data["financial"]
        ? FinancialDto.fromJS(_data["financial"])
        : (undefined as any);
      this.transactionId = _data["transactionId"];
    }
  }

  static fromJS(data: any): UpsertFinancialsHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpsertFinancialsHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["financial"] = this.financial
      ? this.financial.toJSON()
      : (undefined as any);
    data["transactionId"] = this.transactionId;
    return data;
  }
}

export interface IUpsertFinancialsHttpRequest {
  financial?: FinancialDto;
  transactionId?: number;
}

export class FinancialDto implements IFinancialDto {
  commissionPercentage?: number | undefined;
  flatCommissionAmount?: number | undefined;
  clientRebatePercentage?: number | undefined;
  clientRebateGciPercentage?: number | undefined;
  clientRebateFlatAmount?: number | undefined;
  referralFeePaidPercentage?: number | undefined;
  referralFeeReceivedPercentage?: number | undefined;
  coAgentSplitPaidPercentage?: number | undefined;
  coAgentSplit2PaidPercentage?: number | undefined;
  brokerageSplitPercentage?: number | undefined;
  brokerageAdditionalChargePercentage?: number | undefined;
  brokerageFlatFees?: number | undefined;
  incentivesAmount?: number | undefined;
  brokerageAnniversaryDate?: dayjs.Dayjs | undefined;
  date?: dayjs.Dayjs | undefined;

  constructor(data?: IFinancialDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.commissionPercentage = _data["commissionPercentage"];
      this.flatCommissionAmount = _data["flatCommissionAmount"];
      this.clientRebatePercentage = _data["clientRebatePercentage"];
      this.clientRebateGciPercentage = _data["clientRebateGciPercentage"];
      this.clientRebateFlatAmount = _data["clientRebateFlatAmount"];
      this.referralFeePaidPercentage = _data["referralFeePaidPercentage"];
      this.referralFeeReceivedPercentage =
        _data["referralFeeReceivedPercentage"];
      this.coAgentSplitPaidPercentage = _data["coAgentSplitPaidPercentage"];
      this.coAgentSplit2PaidPercentage = _data["coAgentSplit2PaidPercentage"];
      this.brokerageSplitPercentage = _data["brokerageSplitPercentage"];
      this.brokerageAdditionalChargePercentage =
        _data["brokerageAdditionalChargePercentage"];
      this.brokerageFlatFees = _data["brokerageFlatFees"];
      this.incentivesAmount = _data["incentivesAmount"];
      this.brokerageAnniversaryDate = _data["brokerageAnniversaryDate"]
        ? dayjs(_data["brokerageAnniversaryDate"].toString())
        : (undefined as any);
      this.date = _data["date"]
        ? dayjs(_data["date"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): FinancialDto {
    data = typeof data === "object" ? data : {};
    let result = new FinancialDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["commissionPercentage"] = this.commissionPercentage;
    data["flatCommissionAmount"] = this.flatCommissionAmount;
    data["clientRebatePercentage"] = this.clientRebatePercentage;
    data["clientRebateGciPercentage"] = this.clientRebateGciPercentage;
    data["clientRebateFlatAmount"] = this.clientRebateFlatAmount;
    data["referralFeePaidPercentage"] = this.referralFeePaidPercentage;
    data["referralFeeReceivedPercentage"] = this.referralFeeReceivedPercentage;
    data["coAgentSplitPaidPercentage"] = this.coAgentSplitPaidPercentage;
    data["coAgentSplit2PaidPercentage"] = this.coAgentSplit2PaidPercentage;
    data["brokerageSplitPercentage"] = this.brokerageSplitPercentage;
    data["brokerageAdditionalChargePercentage"] =
      this.brokerageAdditionalChargePercentage;
    data["brokerageFlatFees"] = this.brokerageFlatFees;
    data["incentivesAmount"] = this.incentivesAmount;
    data["brokerageAnniversaryDate"] = this.brokerageAnniversaryDate
      ? this.brokerageAnniversaryDate.format("YYYY-MM-DD")
      : (undefined as any);
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    return data;
  }
}

export interface IFinancialDto {
  commissionPercentage?: number | undefined;
  flatCommissionAmount?: number | undefined;
  clientRebatePercentage?: number | undefined;
  clientRebateGciPercentage?: number | undefined;
  clientRebateFlatAmount?: number | undefined;
  referralFeePaidPercentage?: number | undefined;
  referralFeeReceivedPercentage?: number | undefined;
  coAgentSplitPaidPercentage?: number | undefined;
  coAgentSplit2PaidPercentage?: number | undefined;
  brokerageSplitPercentage?: number | undefined;
  brokerageAdditionalChargePercentage?: number | undefined;
  brokerageFlatFees?: number | undefined;
  incentivesAmount?: number | undefined;
  brokerageAnniversaryDate?: dayjs.Dayjs | undefined;
  date?: dayjs.Dayjs | undefined;
}

export class TransactionInfo implements ITransactionInfo {
  id?: number;
  date?: dayjs.Dayjs;
  createdOn?: dayjs.Dayjs;
  isUnderContract?: boolean;
  status?: TransactionStatus;
  leadReceivedDate?: dayjs.Dayjs | undefined;
  isOverdue?: boolean;
  typeId?: number;
  yearId?: number;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  coAgent2Id?: number | undefined;
  address?: Address;
  notes?: string | undefined;
  price?: number;
  specialGroups?: number[] | undefined;
  specialTags?: number[] | undefined;
  soiReferrers?: LookupItemSimple[] | undefined;
  agentReferrers?: LookupItemSimple[] | undefined;
  vendorReferrers?: LookupItemSimple[] | undefined;
  vendors?: LookupItemSimple[] | undefined;
  agentsReferred?: LookupItemSimple[] | undefined;
  clients?: LookupItemSimple[] | undefined;
  referralOutTypeId?: number | undefined;
  createdByEmail?: string | undefined;
  financials?: FinancialInfo | undefined;
  clientNames?: string | undefined;
  formattedAddress?: string | undefined;

  constructor(data?: ITransactionInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.date = _data["date"]
        ? dayjs(_data["date"].toString())
        : (undefined as any);
      this.createdOn = _data["createdOn"]
        ? dayjs(_data["createdOn"].toString())
        : (undefined as any);
      this.isUnderContract = _data["isUnderContract"];
      this.status = _data["status"];
      this.leadReceivedDate = _data["leadReceivedDate"]
        ? dayjs(_data["leadReceivedDate"].toString())
        : (undefined as any);
      this.isOverdue = _data["isOverdue"];
      this.typeId = _data["typeId"];
      this.yearId = _data["yearId"];
      this.sourceId = _data["sourceId"];
      this.reasonId = _data["reasonId"];
      this.areaId = _data["areaId"];
      this.coAgentId = _data["coAgentId"];
      this.coAgent2Id = _data["coAgent2Id"];
      this.address = _data["address"]
        ? Address.fromJS(_data["address"])
        : (undefined as any);
      this.notes = _data["notes"];
      this.price = _data["price"];
      if (Array.isArray(_data["specialGroups"])) {
        this.specialGroups = [] as any;
        for (let item of _data["specialGroups"]) this.specialGroups!.push(item);
      }
      if (Array.isArray(_data["specialTags"])) {
        this.specialTags = [] as any;
        for (let item of _data["specialTags"]) this.specialTags!.push(item);
      }
      if (Array.isArray(_data["soiReferrers"])) {
        this.soiReferrers = [] as any;
        for (let item of _data["soiReferrers"])
          this.soiReferrers!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["agentReferrers"])) {
        this.agentReferrers = [] as any;
        for (let item of _data["agentReferrers"])
          this.agentReferrers!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["vendorReferrers"])) {
        this.vendorReferrers = [] as any;
        for (let item of _data["vendorReferrers"])
          this.vendorReferrers!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["vendors"])) {
        this.vendors = [] as any;
        for (let item of _data["vendors"])
          this.vendors!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["agentsReferred"])) {
        this.agentsReferred = [] as any;
        for (let item of _data["agentsReferred"])
          this.agentsReferred!.push(LookupItemSimple.fromJS(item));
      }
      if (Array.isArray(_data["clients"])) {
        this.clients = [] as any;
        for (let item of _data["clients"])
          this.clients!.push(LookupItemSimple.fromJS(item));
      }
      this.referralOutTypeId = _data["referralOutTypeId"];
      this.createdByEmail = _data["createdByEmail"];
      this.financials = _data["financials"]
        ? FinancialInfo.fromJS(_data["financials"])
        : (undefined as any);
      this.clientNames = _data["clientNames"];
      this.formattedAddress = _data["formattedAddress"];
    }
  }

  static fromJS(data: any): TransactionInfo {
    data = typeof data === "object" ? data : {};
    let result = new TransactionInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["createdOn"] = this.createdOn
      ? this.createdOn.toISOString()
      : (undefined as any);
    data["isUnderContract"] = this.isUnderContract;
    data["status"] = this.status;
    data["leadReceivedDate"] = this.leadReceivedDate ? this.leadReceivedDate.toISOString() : (undefined as any);
    data["isOverdue"] = this.isOverdue;
    data["typeId"] = this.typeId;
    data["yearId"] = this.yearId;
    data["sourceId"] = this.sourceId;
    data["reasonId"] = this.reasonId;
    data["areaId"] = this.areaId;
    data["coAgentId"] = this.coAgentId;
    data["coAgent2Id"] = this.coAgent2Id;
    data["address"] = this.address ? this.address.toJSON() : (undefined as any);
    data["notes"] = this.notes;
    data["price"] = this.price;
    if (Array.isArray(this.specialGroups)) {
      data["specialGroups"] = [];
      for (let item of this.specialGroups) data["specialGroups"].push(item);
    }
    if (Array.isArray(this.specialTags)) {
      data["specialTags"] = [];
      for (let item of this.specialTags) data["specialTags"].push(item);
    }
    if (Array.isArray(this.soiReferrers)) {
      data["soiReferrers"] = [];
      for (let item of this.soiReferrers)
        data["soiReferrers"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.agentReferrers)) {
      data["agentReferrers"] = [];
      for (let item of this.agentReferrers)
        data["agentReferrers"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.vendorReferrers)) {
      data["vendorReferrers"] = [];
      for (let item of this.vendorReferrers)
        data["vendorReferrers"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.vendors)) {
      data["vendors"] = [];
      for (let item of this.vendors)
        data["vendors"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.agentsReferred)) {
      data["agentsReferred"] = [];
      for (let item of this.agentsReferred)
        data["agentsReferred"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.clients)) {
      data["clients"] = [];
      for (let item of this.clients)
        data["clients"].push(item ? item.toJSON() : (undefined as any));
    }
    data["referralOutTypeId"] = this.referralOutTypeId;
    data["createdByEmail"] = this.createdByEmail;
    data["financials"] = this.financials
      ? this.financials.toJSON()
      : (undefined as any);
    data["clientNames"] = this.clientNames;
    data["formattedAddress"] = this.formattedAddress;
    return data;
  }
}

export interface ITransactionInfo {
  id?: number;
  date?: dayjs.Dayjs;
  createdOn?: dayjs.Dayjs;
  isUnderContract?: boolean;
  status?: TransactionStatus;
  leadReceivedDate?: dayjs.Dayjs | undefined;
  isOverdue?: boolean;
  typeId?: number;
  yearId?: number;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  coAgent2Id?: number | undefined;
  address?: Address;
  notes?: string | undefined;
  price?: number;
  specialGroups?: number[] | undefined;
  specialTags?: number[] | undefined;
  soiReferrers?: LookupItemSimple[] | undefined;
  agentReferrers?: LookupItemSimple[] | undefined;
  vendorReferrers?: LookupItemSimple[] | undefined;
  vendors?: LookupItemSimple[] | undefined;
  agentsReferred?: LookupItemSimple[] | undefined;
  clients?: LookupItemSimple[] | undefined;
  referralOutTypeId?: number | undefined;
  createdByEmail?: string | undefined;
  financials?: FinancialInfo | undefined;
  clientNames?: string | undefined;
  formattedAddress?: string | undefined;
}

export class FinancialInfo implements IFinancialInfo {
  commissionPercentage?: number | undefined;
  flatCommissionAmount?: number | undefined;
  clientRebatePercentage?: number | undefined;
  clientRebateGciPercentage?: number | undefined;
  clientRebateFlatAmount?: number | undefined;
  referralFeePaidPercentage?: number | undefined;
  referralFeeReceivedPercentage?: number | undefined;
  coAgentSplitPaidPercentage?: number | undefined;
  coAgentSplit2PaidPercentage?: number | undefined;
  brokerageSplitPercentage?: number | undefined;
  brokerageAdditionalChargePercentage?: number | undefined;
  brokerageFlatFees?: number | undefined;
  incentivesAmount?: number | undefined;
  brokerageAnniversaryDate?: dayjs.Dayjs | undefined;
  brokerageSplitAmount?: number | undefined;
  brokerageAdditionalChargeAmount?: number | undefined;
  grossCommIncomeAmount?: number | undefined;
  clientRebateGciAmount?: number | undefined;
  clientRebateAmount?: number | undefined;
  referralFeePaidAmount?: number | undefined;
  referralFeeReceivedAmount?: number | undefined;
  coAgentSplitPaidAmount?: number | undefined;
  coAgentSplit2PaidAmount?: number | undefined;
  effectiveGciAmount?: number | undefined;
  brokerageTotalFees?: number | undefined;
  netCommissionIncome?: number | undefined;
  netIncome?: number | undefined;
  netIncomePct?: number | undefined;
  runningSplitTotal?: number | undefined;
  runningAdditionalChargeTotal?: number | undefined;

  constructor(data?: IFinancialInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.commissionPercentage = _data["commissionPercentage"];
      this.flatCommissionAmount = _data["flatCommissionAmount"];
      this.clientRebatePercentage = _data["clientRebatePercentage"];
      this.clientRebateGciPercentage = _data["clientRebateGciPercentage"];
      this.clientRebateFlatAmount = _data["clientRebateFlatAmount"];
      this.referralFeePaidPercentage = _data["referralFeePaidPercentage"];
      this.referralFeeReceivedPercentage =
        _data["referralFeeReceivedPercentage"];
      this.coAgentSplitPaidPercentage = _data["coAgentSplitPaidPercentage"];
      this.coAgentSplit2PaidPercentage = _data["coAgentSplit2PaidPercentage"];
      this.brokerageSplitPercentage = _data["brokerageSplitPercentage"];
      this.brokerageAdditionalChargePercentage =
        _data["brokerageAdditionalChargePercentage"];
      this.brokerageFlatFees = _data["brokerageFlatFees"];
      this.incentivesAmount = _data["incentivesAmount"];
      this.brokerageAnniversaryDate = _data["brokerageAnniversaryDate"]
        ? dayjs(_data["brokerageAnniversaryDate"].toString())
        : (undefined as any);
      this.brokerageSplitAmount = _data["brokerageSplitAmount"];
      this.brokerageAdditionalChargeAmount =
        _data["brokerageAdditionalChargeAmount"];
      this.grossCommIncomeAmount = _data["grossCommIncomeAmount"];
      this.clientRebateGciAmount = _data["clientRebateGciAmount"];
      this.clientRebateAmount = _data["clientRebateAmount"];
      this.referralFeePaidAmount = _data["referralFeePaidAmount"];
      this.referralFeeReceivedAmount = _data["referralFeeReceivedAmount"];
      this.coAgentSplitPaidAmount = _data["coAgentSplitPaidAmount"];
      this.coAgentSplit2PaidAmount = _data["coAgentSplit2PaidAmount"];
      this.effectiveGciAmount = _data["effectiveGciAmount"];
      this.brokerageTotalFees = _data["brokerageTotalFees"];
      this.netCommissionIncome = _data["netCommissionIncome"];
      this.netIncome = _data["netIncome"];
      this.netIncomePct = _data["netIncomePct"];
      this.runningSplitTotal = _data["runningSplitTotal"];
      this.runningAdditionalChargeTotal = _data["runningAdditionalChargeTotal"];
    }
  }

  static fromJS(data: any): FinancialInfo {
    data = typeof data === "object" ? data : {};
    let result = new FinancialInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["commissionPercentage"] = this.commissionPercentage;
    data["flatCommissionAmount"] = this.flatCommissionAmount;
    data["clientRebatePercentage"] = this.clientRebatePercentage;
    data["clientRebateGciPercentage"] = this.clientRebateGciPercentage;
    data["clientRebateFlatAmount"] = this.clientRebateFlatAmount;
    data["referralFeePaidPercentage"] = this.referralFeePaidPercentage;
    data["referralFeeReceivedPercentage"] = this.referralFeeReceivedPercentage;
    data["coAgentSplitPaidPercentage"] = this.coAgentSplitPaidPercentage;
    data["coAgentSplit2PaidPercentage"] = this.coAgentSplit2PaidPercentage;
    data["brokerageSplitPercentage"] = this.brokerageSplitPercentage;
    data["brokerageAdditionalChargePercentage"] =
      this.brokerageAdditionalChargePercentage;
    data["brokerageFlatFees"] = this.brokerageFlatFees;
    data["incentivesAmount"] = this.incentivesAmount;
    data["brokerageAnniversaryDate"] = this.brokerageAnniversaryDate
      ? this.brokerageAnniversaryDate.toISOString()
      : (undefined as any);
    data["brokerageSplitAmount"] = this.brokerageSplitAmount;
    data["brokerageAdditionalChargeAmount"] =
      this.brokerageAdditionalChargeAmount;
    data["grossCommIncomeAmount"] = this.grossCommIncomeAmount;
    data["clientRebateGciAmount"] = this.clientRebateGciAmount;
    data["clientRebateAmount"] = this.clientRebateAmount;
    data["referralFeePaidAmount"] = this.referralFeePaidAmount;
    data["referralFeeReceivedAmount"] = this.referralFeeReceivedAmount;
    data["coAgentSplitPaidAmount"] = this.coAgentSplitPaidAmount;
    data["coAgentSplit2PaidAmount"] = this.coAgentSplit2PaidAmount;
    data["effectiveGciAmount"] = this.effectiveGciAmount;
    data["brokerageTotalFees"] = this.brokerageTotalFees;
    data["netCommissionIncome"] = this.netCommissionIncome;
    data["netIncome"] = this.netIncome;
    data["netIncomePct"] = this.netIncomePct;
    data["runningSplitTotal"] = this.runningSplitTotal;
    data["runningAdditionalChargeTotal"] = this.runningAdditionalChargeTotal;
    return data;
  }
}

export interface IFinancialInfo {
  commissionPercentage?: number | undefined;
  flatCommissionAmount?: number | undefined;
  clientRebatePercentage?: number | undefined;
  clientRebateGciPercentage?: number | undefined;
  clientRebateFlatAmount?: number | undefined;
  referralFeePaidPercentage?: number | undefined;
  referralFeeReceivedPercentage?: number | undefined;
  coAgentSplitPaidPercentage?: number | undefined;
  coAgentSplit2PaidPercentage?: number | undefined;
  brokerageSplitPercentage?: number | undefined;
  brokerageAdditionalChargePercentage?: number | undefined;
  brokerageFlatFees?: number | undefined;
  incentivesAmount?: number | undefined;
  brokerageAnniversaryDate?: dayjs.Dayjs | undefined;
  brokerageSplitAmount?: number | undefined;
  brokerageAdditionalChargeAmount?: number | undefined;
  grossCommIncomeAmount?: number | undefined;
  clientRebateGciAmount?: number | undefined;
  clientRebateAmount?: number | undefined;
  referralFeePaidAmount?: number | undefined;
  referralFeeReceivedAmount?: number | undefined;
  coAgentSplitPaidAmount?: number | undefined;
  coAgentSplit2PaidAmount?: number | undefined;
  effectiveGciAmount?: number | undefined;
  brokerageTotalFees?: number | undefined;
  netCommissionIncome?: number | undefined;
  netIncome?: number | undefined;
  netIncomePct?: number | undefined;
  runningSplitTotal?: number | undefined;
  runningAdditionalChargeTotal?: number | undefined;
}

export class TransactionSearchInfo implements ITransactionSearchInfo {
  id?: number;
  date?: dayjs.Dayjs;
  createdOn?: dayjs.Dayjs;
  isUnderContract?: boolean;
  status?: TransactionStatus;
  leadReceivedDate?: dayjs.Dayjs | undefined;
  typeId?: number;
  yearId?: number;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  notes?: string | undefined;
  price?: number;
  grossCommIncomeAmt?: number | undefined;
  netIncome?: number | undefined;
  createdByEmail?: string | undefined;
  clientNames?: string | undefined;
  formattedAddress?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  street?: string | undefined;
  zip?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;

  constructor(data?: ITransactionSearchInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.date = _data["date"]
        ? dayjs(_data["date"].toString())
        : (undefined as any);
      this.createdOn = _data["createdOn"]
        ? dayjs(_data["createdOn"].toString())
        : (undefined as any);
      this.isUnderContract = _data["isUnderContract"];
      this.status = _data["status"];
      this.leadReceivedDate = _data["leadReceivedDate"]
        ? dayjs(_data["leadReceivedDate"].toString())
        : (undefined as any);
      this.typeId = _data["typeId"];
      this.yearId = _data["yearId"];
      this.sourceId = _data["sourceId"];
      this.reasonId = _data["reasonId"];
      this.areaId = _data["areaId"];
      this.coAgentId = _data["coAgentId"];
      this.notes = _data["notes"];
      this.price = _data["price"];
      this.grossCommIncomeAmt = _data["grossCommIncomeAmt"];
      this.netIncome = _data["netIncome"];
      this.createdByEmail = _data["createdByEmail"];
      this.clientNames = _data["clientNames"];
      this.formattedAddress = _data["formattedAddress"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.street = _data["street"];
      this.zip = _data["zip"];
      this.latitude = _data["latitude"];
      this.longitude = _data["longitude"];
    }
  }

  static fromJS(data: any): TransactionSearchInfo {
    data = typeof data === "object" ? data : {};
    let result = new TransactionSearchInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["createdOn"] = this.createdOn
      ? this.createdOn.toISOString()
      : (undefined as any);
    data["isUnderContract"] = this.isUnderContract;
    data["status"] = this.status;
    data["leadReceivedDate"] = this.leadReceivedDate ? this.leadReceivedDate.toISOString() : (undefined as any);
    data["typeId"] = this.typeId;
    data["yearId"] = this.yearId;
    data["sourceId"] = this.sourceId;
    data["reasonId"] = this.reasonId;
    data["areaId"] = this.areaId;
    data["coAgentId"] = this.coAgentId;
    data["notes"] = this.notes;
    data["price"] = this.price;
    data["grossCommIncomeAmt"] = this.grossCommIncomeAmt;
    data["netIncome"] = this.netIncome;
    data["createdByEmail"] = this.createdByEmail;
    data["clientNames"] = this.clientNames;
    data["formattedAddress"] = this.formattedAddress;
    data["city"] = this.city;
    data["state"] = this.state;
    data["street"] = this.street;
    data["zip"] = this.zip;
    data["latitude"] = this.latitude;
    data["longitude"] = this.longitude;
    return data;
  }
}

export interface ITransactionSearchInfo {
  id?: number;
  date?: dayjs.Dayjs;
  createdOn?: dayjs.Dayjs;
  isUnderContract?: boolean;
  status?: TransactionStatus;
  leadReceivedDate?: dayjs.Dayjs | undefined;
  typeId?: number;
  yearId?: number;
  sourceId?: number | undefined;
  reasonId?: number | undefined;
  areaId?: number | undefined;
  coAgentId?: number | undefined;
  notes?: string | undefined;
  price?: number;
  grossCommIncomeAmt?: number | undefined;
  netIncome?: number | undefined;
  createdByEmail?: string | undefined;
  clientNames?: string | undefined;
  formattedAddress?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  street?: string | undefined;
  zip?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
}

export class PagedResultOfTransactionInfo implements IPagedResultOfTransactionInfo {
  result?: TransactionInfo[];
  totalCount?: number;

  constructor(data?: IPagedResultOfTransactionInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["result"])) {
        this.result = [] as any;
        for (let item of _data["result"])
          this.result!.push(TransactionInfo.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
    }
  }

  static fromJS(data: any): PagedResultOfTransactionInfo {
    data = typeof data === "object" ? data : {};
    let result = new PagedResultOfTransactionInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.result)) {
      data["result"] = [];
      for (let item of this.result)
        data["result"].push(item ? item.toJSON() : (undefined as any));
    }
    data["totalCount"] = this.totalCount;
    return data;
  }
}

export interface IPagedResultOfTransactionInfo {
  result?: TransactionInfo[];
  totalCount?: number;
}

export class GetTransactionHttpResponse implements IGetTransactionHttpResponse {
  transactionDetail?: TransactionInfo | undefined;

  constructor(data?: IGetTransactionHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionDetail = _data["transactionDetail"]
        ? TransactionInfo.fromJS(_data["transactionDetail"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): GetTransactionHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetTransactionHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["transactionDetail"] = this.transactionDetail
      ? this.transactionDetail.toJSON()
      : (undefined as any);
    return data;
  }
}

export interface IGetTransactionHttpResponse {
  transactionDetail?: TransactionInfo | undefined;
}

export class PrefillData implements IPrefillData {
  brokerageAnniversaryDate?: dayjs.Dayjs;
  totalBrokerageAdditionalCharge?: number;
  totalBrokerageSplit?: number;
  commissionPctUnlinked?: boolean | undefined;
  brokerageSplitUnlinked?: boolean | undefined;
  additionalChargesUnlinked?: boolean | undefined;
  brokerageFlatFeesUnlinked?: boolean | undefined;
  flatCommissionFeeUnlinked?: boolean | undefined;
  referralOutFeeReceivedUnlinked?: boolean | undefined;
  referralFeePaidUnlinked?: boolean | undefined;

  constructor(data?: IPrefillData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.brokerageAnniversaryDate = _data["brokerageAnniversaryDate"]
        ? dayjs(_data["brokerageAnniversaryDate"].toString())
        : (undefined as any);
      this.totalBrokerageAdditionalCharge =
        _data["totalBrokerageAdditionalCharge"];
      this.totalBrokerageSplit = _data["totalBrokerageSplit"];
      this.commissionPctUnlinked = _data["commissionPctUnlinked"];
      this.brokerageSplitUnlinked = _data["brokerageSplitUnlinked"];
      this.additionalChargesUnlinked = _data["additionalChargesUnlinked"];
      this.brokerageFlatFeesUnlinked = _data["brokerageFlatFeesUnlinked"];
      this.flatCommissionFeeUnlinked = _data["flatCommissionFeeUnlinked"];
      this.referralOutFeeReceivedUnlinked =
        _data["referralOutFeeReceivedUnlinked"];
      this.referralFeePaidUnlinked = _data["referralFeePaidUnlinked"];
    }
  }

  static fromJS(data: any): PrefillData {
    data = typeof data === "object" ? data : {};
    let result = new PrefillData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["brokerageAnniversaryDate"] = this.brokerageAnniversaryDate
      ? this.brokerageAnniversaryDate.toISOString()
      : (undefined as any);
    data["totalBrokerageAdditionalCharge"] =
      this.totalBrokerageAdditionalCharge;
    data["totalBrokerageSplit"] = this.totalBrokerageSplit;
    data["commissionPctUnlinked"] = this.commissionPctUnlinked;
    data["brokerageSplitUnlinked"] = this.brokerageSplitUnlinked;
    data["additionalChargesUnlinked"] = this.additionalChargesUnlinked;
    data["brokerageFlatFeesUnlinked"] = this.brokerageFlatFeesUnlinked;
    data["flatCommissionFeeUnlinked"] = this.flatCommissionFeeUnlinked;
    data["referralOutFeeReceivedUnlinked"] =
      this.referralOutFeeReceivedUnlinked;
    data["referralFeePaidUnlinked"] = this.referralFeePaidUnlinked;
    return data;
  }
}

export interface IPrefillData {
  brokerageAnniversaryDate?: dayjs.Dayjs;
  totalBrokerageAdditionalCharge?: number;
  totalBrokerageSplit?: number;
  commissionPctUnlinked?: boolean | undefined;
  brokerageSplitUnlinked?: boolean | undefined;
  additionalChargesUnlinked?: boolean | undefined;
  brokerageFlatFeesUnlinked?: boolean | undefined;
  flatCommissionFeeUnlinked?: boolean | undefined;
  referralOutFeeReceivedUnlinked?: boolean | undefined;
  referralFeePaidUnlinked?: boolean | undefined;
}

export class ImportSettlementDataHttpRequest implements IImportSettlementDataHttpRequest {
  settlementData?: SettlementInfo[];
  duplicateAction?: DuplicateActionEnum;

  constructor(data?: IImportSettlementDataHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["settlementData"])) {
        this.settlementData = [] as any;
        for (let item of _data["settlementData"])
          this.settlementData!.push(SettlementInfo.fromJS(item));
      }
      this.duplicateAction = _data["duplicateAction"];
    }
  }

  static fromJS(data: any): ImportSettlementDataHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new ImportSettlementDataHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.settlementData)) {
      data["settlementData"] = [];
      for (let item of this.settlementData)
        data["settlementData"].push(item ? item.toJSON() : (undefined as any));
    }
    data["duplicateAction"] = this.duplicateAction;
    return data;
  }
}

export interface IImportSettlementDataHttpRequest {
  settlementData?: SettlementInfo[];
  duplicateAction?: DuplicateActionEnum;
}

export class SettlementInfo implements ISettlementInfo {
  id?: string;
  transactionTypeId?: number;
  propertyAddress?: string | undefined;
  settlementDate?: dayjs.Dayjs;
  buyers?: string[] | undefined;
  sellers?: string[] | undefined;
  address?: Address;
  clients?: string[] | undefined;
  price?: number;

  constructor(data?: ISettlementInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.transactionTypeId = _data["transactionTypeId"];
      this.propertyAddress = _data["propertyAddress"];
      this.settlementDate = _data["settlementDate"]
        ? dayjs(_data["settlementDate"].toString())
        : (undefined as any);
      if (Array.isArray(_data["buyers"])) {
        this.buyers = [] as any;
        for (let item of _data["buyers"]) this.buyers!.push(item);
      }
      if (Array.isArray(_data["sellers"])) {
        this.sellers = [] as any;
        for (let item of _data["sellers"]) this.sellers!.push(item);
      }
      this.address = _data["address"]
        ? Address.fromJS(_data["address"])
        : (undefined as any);
      if (Array.isArray(_data["clients"])) {
        this.clients = [] as any;
        for (let item of _data["clients"]) this.clients!.push(item);
      }
      this.price = _data["price"];
    }
  }

  static fromJS(data: any): SettlementInfo {
    data = typeof data === "object" ? data : {};
    let result = new SettlementInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["transactionTypeId"] = this.transactionTypeId;
    data["propertyAddress"] = this.propertyAddress;
    data["settlementDate"] = this.settlementDate
      ? this.settlementDate.toISOString()
      : (undefined as any);
    if (Array.isArray(this.buyers)) {
      data["buyers"] = [];
      for (let item of this.buyers) data["buyers"].push(item);
    }
    if (Array.isArray(this.sellers)) {
      data["sellers"] = [];
      for (let item of this.sellers) data["sellers"].push(item);
    }
    data["address"] = this.address ? this.address.toJSON() : (undefined as any);
    if (Array.isArray(this.clients)) {
      data["clients"] = [];
      for (let item of this.clients) data["clients"].push(item);
    }
    data["price"] = this.price;
    return data;
  }
}

export interface ISettlementInfo {
  id?: string;
  transactionTypeId?: number;
  propertyAddress?: string | undefined;
  settlementDate?: dayjs.Dayjs;
  buyers?: string[] | undefined;
  sellers?: string[] | undefined;
  address?: Address;
  clients?: string[] | undefined;
  price?: number;
}

export enum DuplicateActionEnum {
  Overwrite = 0,
  Skip = 1,
  AddAsNew = 2,
}

export class UpdateLinkageHttpRequest implements IUpdateLinkageHttpRequest {
  transactionId?: number;
  field?: LinkFieldEnum;
  isLinked?: boolean;

  constructor(data?: IUpdateLinkageHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionId = _data["transactionId"];
      this.field = _data["field"];
      this.isLinked = _data["isLinked"];
    }
  }

  static fromJS(data: any): UpdateLinkageHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateLinkageHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["transactionId"] = this.transactionId;
    data["field"] = this.field;
    data["isLinked"] = this.isLinked;
    return data;
  }
}

export interface IUpdateLinkageHttpRequest {
  transactionId?: number;
  field?: LinkFieldEnum;
  isLinked?: boolean;
}

export class UpdatePipelineStatusHttpRequest
  implements IUpdatePipelineStatusHttpRequest
{
  transactionId?: number;
  status?: TransactionStatus;

  constructor(data?: IUpdatePipelineStatusHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.transactionId = _data["transactionId"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): UpdatePipelineStatusHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdatePipelineStatusHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["transactionId"] = this.transactionId;
    data["status"] = this.status;
    return data;
  }
}

export interface IUpdatePipelineStatusHttpRequest {
  transactionId?: number;
  status?: TransactionStatus;
}

export enum LinkFieldEnum {
  CommissionPct = 1,
  BrokerageSplit = 2,
  AdditionalCharges = 3,
  BrokerageFlatFees = 4,
  FlatCommissionFee = 5,
  ReferralOutFeeReceived = 6,
  ReferralFeePaid = 7,
}

export class EntityRepeatInfo implements IEntityRepeatInfo {
  id?: number;
  name?: string;
  count?: number;
  repeatCount?: number | undefined;
  referralCount?: number | undefined;
  totalVolume?: number;
  totalGci?: number | undefined;
  totalNetIncome?: number | undefined;
  averagePrice?: number;

  constructor(data?: IEntityRepeatInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.count = _data["count"];
      this.repeatCount = _data["repeatCount"];
      this.referralCount = _data["referralCount"];
      this.totalVolume = _data["totalVolume"];
      this.totalGci = _data["totalGci"];
      this.totalNetIncome = _data["totalNetIncome"];
      this.averagePrice = _data["averagePrice"];
    }
  }

  static fromJS(data: any): EntityRepeatInfo {
    data = typeof data === "object" ? data : {};
    let result = new EntityRepeatInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["count"] = this.count;
    data["repeatCount"] = this.repeatCount;
    data["referralCount"] = this.referralCount;
    data["totalVolume"] = this.totalVolume;
    data["totalGci"] = this.totalGci;
    data["totalNetIncome"] = this.totalNetIncome;
    data["averagePrice"] = this.averagePrice;
    return data;
  }
}

export interface IEntityRepeatInfo {
  id?: number;
  name?: string;
  count?: number;
  repeatCount?: number | undefined;
  referralCount?: number | undefined;
  totalVolume?: number;
  totalGci?: number | undefined;
  totalNetIncome?: number | undefined;
  averagePrice?: number;
}

export enum TransactionRepeatEnum {
  Client = 0,
  Vendor = 1,
  Agent = 2,
  Soi = 3,
  Referred = 4,
  ClientRepeatsAndReferrers = 5,
}

export class TransactionNavigationResponse implements ITransactionNavigationResponse {
  previousTransactionId?: number | undefined;
  nextTransactionId?: number | undefined;

  constructor(data?: ITransactionNavigationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.previousTransactionId = _data["previousTransactionId"];
      this.nextTransactionId = _data["nextTransactionId"];
    }
  }

  static fromJS(data: any): TransactionNavigationResponse {
    data = typeof data === "object" ? data : {};
    let result = new TransactionNavigationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["previousTransactionId"] = this.previousTransactionId;
    data["nextTransactionId"] = this.nextTransactionId;
    return data;
  }
}

export interface ITransactionNavigationResponse {
  previousTransactionId?: number | undefined;
  nextTransactionId?: number | undefined;
}

export class User implements IUser {
  userId?: string;
  email?: string;
  name?: string;
  paymentStatus?: string | undefined;
  stripeCustomerId?: string | undefined;
  subscriptionId?: string | undefined;
  plan?: string | undefined;
  isPro?: boolean;
  subscriptionStatus?: string | undefined;
  currentPeriodEnd?: dayjs.Dayjs | undefined;
  trialEnd?: dayjs.Dayjs | undefined;
  priceId?: string | undefined;
  productId?: string | undefined;
  planInterval?: string | undefined;
  planAmount?: number | undefined;
  isAdmin?: boolean;

  constructor(data?: IUser) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.email = _data["email"];
      this.name = _data["name"];
      this.paymentStatus = _data["paymentStatus"];
      this.stripeCustomerId = _data["stripeCustomerId"];
      this.subscriptionId = _data["subscriptionId"];
      this.plan = _data["plan"];
      this.isPro = _data["isPro"];
      this.subscriptionStatus = _data["subscriptionStatus"];
      this.currentPeriodEnd = _data["currentPeriodEnd"]
        ? dayjs(_data["currentPeriodEnd"].toString())
        : (undefined as any);
      this.trialEnd = _data["trialEnd"]
        ? dayjs(_data["trialEnd"].toString())
        : (undefined as any);
      this.priceId = _data["priceId"];
      this.productId = _data["productId"];
      this.planInterval = _data["planInterval"];
      this.planAmount = _data["planAmount"];
      this.isAdmin = _data["isAdmin"];
    }
  }

  static fromJS(data: any): User {
    data = typeof data === "object" ? data : {};
    let result = new User();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.userId;
    data["email"] = this.email;
    data["name"] = this.name;
    data["paymentStatus"] = this.paymentStatus;
    data["stripeCustomerId"] = this.stripeCustomerId;
    data["subscriptionId"] = this.subscriptionId;
    data["plan"] = this.plan;
    data["isPro"] = this.isPro;
    data["subscriptionStatus"] = this.subscriptionStatus;
    data["currentPeriodEnd"] = this.currentPeriodEnd
      ? this.currentPeriodEnd.toISOString()
      : (undefined as any);
    data["trialEnd"] = this.trialEnd
      ? this.trialEnd.toISOString()
      : (undefined as any);
    data["priceId"] = this.priceId;
    data["productId"] = this.productId;
    data["planInterval"] = this.planInterval;
    data["planAmount"] = this.planAmount;
    data["isAdmin"] = this.isAdmin;
    return data;
  }
}

export interface IUser {
  userId?: string;
  email?: string;
  name?: string;
  paymentStatus?: string | undefined;
  stripeCustomerId?: string | undefined;
  subscriptionId?: string | undefined;
  plan?: string | undefined;
  isPro?: boolean;
  subscriptionStatus?: string | undefined;
  currentPeriodEnd?: dayjs.Dayjs | undefined;
  trialEnd?: dayjs.Dayjs | undefined;
  priceId?: string | undefined;
  productId?: string | undefined;
  planInterval?: string | undefined;
  planAmount?: number | undefined;
  isAdmin?: boolean;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any,
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

const customTimeParser: PluginFunc = (option, dayjsClass, dayjsFactory) => {
  const proto: any = dayjsClass.prototype;
  const oldParse = proto.parse;
  proto.parse = function (cfg: any) {
    const { date } = cfg;
    if (
      typeof date === "string" &&
      date &&
      date.length === 8 &&
      date.split(":").length === 3
    ) {
      cfg.date = "1970-01-01T" + date;
    }
    oldParse.call(this, cfg);
  };
};

dayjs.extend(customTimeParser);
